import React, { useState } from 'react';

// SF Symbol-inspired SVG icons — replaces emoji throughout the app
const PhoneIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.5 10.81 19.79 19.79 0 01.43 2.18 2 2 0 012.42 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.06a16 16 0 006.85 6.85l1.41-1.41a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const SparklesIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.9 5.8L19 10.5l-5.1 1.7L12 18l-1.9-5.8L5 10.5l5.1-1.7L12 3z"/>
    <path d="M5 3v3M3.5 4.5h3"/><path d="M19 17v3M17.5 18.5h3"/>
  </svg>
);
const MicIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/>
    <path d="M19 10v2a7 7 0 01-14 0v-2"/>
    <line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
  </svg>
);
const VideoIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7"/>
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
  </svg>
);
const CalendarIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const PencilIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const ClipboardIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
  </svg>
);
const QuestionIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const GlobeIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
  </svg>
);
const MessageIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);
const CloseIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/>
  </svg>
);
const CheckIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="1.5 7.5 5 11 12.5 3"/>
  </svg>
);
const SendIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const ChevronLeftIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);
const MapPinIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

function SolvynApp() {
  // Add CSS for animations
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
      }
      @keyframes slideInRight {
        from { transform: translateX(100%); }
        to { transform: translateX(0); }
      }
      @keyframes slideInLeft {
        from { transform: translateX(-100%); }
        to { transform: translateX(0); }
      }
      @keyframes screenFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      .screen-slide-right {
        animation: slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
      }
      .screen-slide-left {
        animation: slideInLeft 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;
      }
      .screen-fade {
        animation: screenFadeIn 0.22s ease both;
      }
      @keyframes fadeUpIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .fade-up-in {
        animation: fadeUpIn 0.2s ease both;
      }
      @keyframes celebrationPop {
        0% { opacity: 0; transform: scale(0.6); }
        70% { transform: scale(1.08); }
        100% { opacity: 1; transform: scale(1); }
      }
      .celebration-pop {
        animation: celebrationPop 0.5s cubic-bezier(0.34,1.56,0.64,1) both;
      }
      @keyframes obPulseRing {
        0% { transform: scale(1); opacity: 0.5; }
        100% { transform: scale(2.2); opacity: 0; }
      }
      @keyframes obLogoBreath {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.04); }
      }
      @keyframes obStatusIn {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const [currentScreen, setCurrentScreen] = useState('splash');
  const [transitionClass, setTransitionClass] = useState('screen-fade');
  const [expandedMilestones, setExpandedMilestones] = useState({ 5: true }); // Milestone 6 (index 5) starts expanded
  const [milestoneExplanationExpanded, setMilestoneExplanationExpanded] = useState(false);
  const [demoMode, setDemoMode] = useState(false);
  const [showAIChat, setShowAIChat] = useState(false);
  const [activeScenario, setActiveScenario] = useState(null);
  const [aiMessages, setAiMessages] = useState([]);
  const [aiWorking, setAiWorking] = useState(false);
  const [highlightedTask, setHighlightedTask] = useState(null);
  const [highlightedFields, setHighlightedFields] = useState([]);
  const [aiTasks, setAiTasks] = useState([]);
  const [aiMilestones, setAiMilestones] = useState([]);
  const [discoverPhase, setDiscoverPhase] = useState('empty'); // 'empty', 'ai-engagement', 'conversation', 'view-results', 'results'
  const [discoverMessages, setDiscoverMessages] = useState([]);
  const [discoverWorking, setDiscoverWorking] = useState(false);
  const [userInput, setUserInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [chatbotManuallyClosed, setChatbotManuallyClosed] = useState(false);
  const [showTypingButton, setShowTypingButton] = useState(false);
  const [aiTypingText, setAiTypingText] = useState('');
  const [showHomePrompt, setShowHomePrompt] = useState(false);
  const [homePromptMessages, setHomePromptMessages] = useState([]);
  const [homePromptInput, setHomePromptInput] = useState('');
  const [homePromptWorking, setHomePromptWorking] = useState(false);
  const [aiChatInput, setAiChatInput] = useState('');
  const [greetingDismissed, setGreetingDismissed] = useState(false);
  const [greetingFading, setGreetingFading] = useState(false);
  const [pulseState, setPulseState] = useState('steady');

  // Onboarding state
  const [onboardingGoal, setOnboardingGoal] = useState(null);
  const [onboardingRelationship, setOnboardingRelationship] = useState(null);
  const [onboardingSituation, setOnboardingSituation] = useState(null);
  const [onboardingTimeline, setOnboardingTimeline] = useState(null);
  const [onboardingConcern, setOnboardingConcern] = useState(null);
  const [onboardingZip, setOnboardingZip] = useState('');
  const [onboardingPersonName, setOnboardingPersonName] = useState('');
  const [onboardingChatMessages, setOnboardingChatMessages] = useState([]);
  const [onboardingChatStage, setOnboardingChatStage] = useState(0);
  const [onboardingAITyping, setOnboardingAITyping] = useState(false);
  const [onboardingAITypingText, setOnboardingAITypingText] = useState('');
  const [onboardingUserTyping, setOnboardingUserTyping] = useState(false);
  const [onboardingUserTypingText, setOnboardingUserTypingText] = useState('');
  const [onboardingRoadmapExpanded, setOnboardingRoadmapExpanded] = useState({ 0: true });
  const [onboardingSaveEmail, setOnboardingSaveEmail] = useState('');
  const [onboardingBuildingStep, setOnboardingBuildingStep] = useState(0);

  // Phase 1 — Caregiver intake
  const [obCaregiverFirstName, setObCaregiverFirstName] = useState('');
  const [obCaregiverLastName, setObCaregiverLastName] = useState('');
  const [obCaregiverDOB, setObCaregiverDOB] = useState('');
  const [obCaregiverIncome, setObCaregiverIncome] = useState(null);
  const [obCaregiverTransport, setObCaregiverTransport] = useState(null);
  const [obFamilyInvolved, setObFamilyInvolved] = useState(null);
  // Phase 2 — Care recipient intake
  const [obRecipientFirstName, setObRecipientFirstName] = useState('');
  const [obRecipientLastName, setObRecipientLastName] = useState('');
  const [obRecipientDOB, setObRecipientDOB] = useState('');
  const [obRecipientRelationship, setObRecipientRelationship] = useState(null);
  const [obRecipientIncome, setObRecipientIncome] = useState(null);
  const [obRecipientTransport, setObRecipientTransport] = useState(null);
  const [obRecipientLanguages, setObRecipientLanguages] = useState([]);
  const [obRecipientConditions, setObRecipientConditions] = useState([]);
  // Intake screen mechanics (stage = which user-input panel is active; 0 = not started)
  const [obIntakeStage, setObIntakeStage] = useState(0);
  const [obIntakeMessages, setObIntakeMessages] = useState([]);
  const [obIntakeAITyping, setObIntakeAITyping] = useState(false);
  const [obIntakeAITypingText, setObIntakeAITypingText] = useState('');
  // Goals screen
  const [obGoalsStage, setObGoalsStage] = useState(0);
  const [obGoalsMessages, setObGoalsMessages] = useState([]);
  const [obGoalsAITyping, setObGoalsAITyping] = useState(false);
  const [obGoalsAITypingText, setObGoalsAITypingText] = useState('');
  const [obGoalsInput, setObGoalsInput] = useState('');
  const [obLanguageOtherText, setObLanguageOtherText] = useState('');

  function dismissGreeting() {
    setGreetingFading(true);
    setTimeout(function() { setGreetingDismissed(true); }, 350);
  }

  function startOnboarding() {
    setOnboardingGoal(null);
    setOnboardingRelationship(null);
    setOnboardingSituation(null);
    setOnboardingTimeline(null);
    setOnboardingConcern(null);
    setOnboardingZip('');
    setOnboardingPersonName('');
    setOnboardingChatMessages([]);
    setOnboardingChatStage(0);
    setOnboardingAITyping(false);
    setOnboardingAITypingText('');
    setOnboardingUserTyping(false);
    setOnboardingUserTypingText('');
    setOnboardingRoadmapExpanded({ 0: true });
    setOnboardingSaveEmail('');
    // New intake state
    setObCaregiverFirstName('');
    setObCaregiverLastName('');
    setObCaregiverDOB('');
    setObCaregiverIncome(null);
    setObCaregiverTransport(null);
    setObFamilyInvolved(null);
    setObRecipientFirstName('');
    setObRecipientLastName('');
    setObRecipientDOB('');
    setObRecipientRelationship(null);
    setObRecipientIncome(null);
    setObRecipientTransport(null);
    setObRecipientLanguages([]);
    setObRecipientConditions([]);
    setObIntakeStage(0);
    setObIntakeMessages([]);
    setObIntakeAITyping(false);
    setObIntakeAITypingText('');
    setObGoalsStage(0);
    setObGoalsMessages([]);
    setObGoalsAITyping(false);
    setObGoalsAITypingText('');
    setObGoalsInput('');
    setObLanguageOtherText('');
    setCurrentScreen('onboarding-welcome');
  }

  function simulateOnboardingAITyping(message, callback) {
    var index = 0;
    setOnboardingAITyping(true);
    setOnboardingAITypingText('');
    var typeInterval = setInterval(function() {
      if (index < message.length) {
        setOnboardingAITypingText(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setOnboardingAITyping(false);
        setOnboardingChatMessages(function(prev) { return [...prev, { type: 'ai', text: message }]; });
        setOnboardingAITypingText('');
        if (callback) callback();
      }
    }, 55); // 55ms/char — readable, not rushed
  }

  function simulateOnboardingUserTyping(message, callback) {
    var index = 0;
    setOnboardingUserTyping(true);
    setOnboardingUserTypingText('');
    var typeInterval = setInterval(function() {
      if (index < message.length) {
        setOnboardingUserTypingText(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setOnboardingUserTyping(false);
        setOnboardingChatMessages(function(prev) { return [...prev, { type: 'user', text: message }]; });
        setOnboardingUserTypingText('');
        if (callback) callback();
      }
    }, 80); // 80ms/char — natural human typing pace
  }

  function calculateAge(dobString) {
    if (!dobString) return null;
    var today = new Date();
    var birth = new Date(dobString + 'T00:00:00');
    var age = today.getFullYear() - birth.getFullYear();
    var m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    return age;
  }

  function formatDOB(dobString) {
    var d = new Date(dobString + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  function simulateIntakeAITyping(message, callback) {
    var index = 0;
    setObIntakeAITyping(true);
    setObIntakeAITypingText('');
    var typeInterval = setInterval(function() {
      if (index < message.length) {
        setObIntakeAITypingText(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setObIntakeAITyping(false);
        setObIntakeMessages(function(prev) { return [...prev, { type: 'ai', text: message }]; });
        setObIntakeAITypingText('');
        if (callback) callback();
      }
    }, 20);
  }

  function addIntakeUserMessage(text) {
    setObIntakeMessages(function(prev) { return [...prev, { type: 'user', text: text }]; });
  }

  function simulateGoalsAITyping(message, callback) {
    var index = 0;
    setObGoalsAITyping(true);
    setObGoalsAITypingText('');
    var typeInterval = setInterval(function() {
      if (index < message.length) {
        setObGoalsAITypingText(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setObGoalsAITyping(false);
        setObGoalsMessages(function(prev) { return [...prev, { type: 'ai', text: message }]; });
        setObGoalsAITypingText('');
        if (callback) callback();
      }
    }, 30);
  }

  // ── Intake submit handlers ───────────────────────────────────────────────────────────────────────────

  function submitPulseChoice(id, label) {
    var pulseMap = { ready: "great", anxious: "strained", holding: "steady", overwhelmed: "overwhelmed", exhausted: "overwhelmed" };
    setPulseState(pulseMap[id] || "steady");
    setOnboardingConcern(id);
    addIntakeUserMessage(label);
    simulateIntakeAITyping(
      "Thank you for sharing that. Where are you located? Your ZIP code helps me find local resources and services in your area.",
      function() { setObIntakeStage(2); }
    );
  }

  function submitZip() {
    if (!onboardingZip || onboardingZip.length !== 5) return;
    addIntakeUserMessage(onboardingZip);
    simulateIntakeAITyping("Got it. What's your name?", function() { setObIntakeStage(3); });
  }

  function submitCaregiverName() {
    if (!obCaregiverFirstName.trim() || !obCaregiverLastName.trim()) return;
    addIntakeUserMessage(obCaregiverFirstName.trim() + ' ' + obCaregiverLastName.trim());
    simulateIntakeAITyping(
      "Nice to meet you, " + obCaregiverFirstName.trim() + ". When were you born? You'll need to be 18 or older to use Solvyn.",
      function() { setObIntakeStage(4); }
    );
  }

  function submitCaregiverDOB() {
    var age = calculateAge(obCaregiverDOB);
    if (age === null || age < 18) return;
    addIntakeUserMessage(formatDOB(obCaregiverDOB));
    simulateIntakeAITyping(
      "To help connect you with the right support programs, which income range best describes your household?",
      function() { setObIntakeStage(5); }
    );
  }

  function submitCaregiverIncome(bracket) {
    setObCaregiverIncome(bracket);
    addIntakeUserMessage(bracket);
    simulateIntakeAITyping(
      "Got it. Do you have reliable access to transportation?",
      function() { setObIntakeStage(6); }
    );
  }

  function submitCaregiverTransport(val) {
    setObCaregiverTransport(val);
    addIntakeUserMessage(val ? "Yes" : "No");
    simulateIntakeAITyping(
      "Thanks. Will other family members or close friends be joining you in this caregiving journey?",
      function() { setObIntakeStage(7); }
    );
  }

  function submitFamilyInvolved(val) {
    setObFamilyInvolved(val);
    addIntakeUserMessage(val ? "Yes" : "No");
    simulateIntakeAITyping(
      "Now let me learn about the person you're caring for. What's their name?",
      function() { setObIntakeStage(8); }
    );
  }

  function submitRecipientName() {
    if (!obRecipientFirstName.trim() || !obRecipientLastName.trim()) return;
    addIntakeUserMessage(obRecipientFirstName.trim() + ' ' + obRecipientLastName.trim());
    simulateIntakeAITyping(
      "And when was " + obRecipientFirstName.trim() + " born?",
      function() { setObIntakeStage(9); }
    );
  }

  function submitRecipientDOB() {
    if (!obRecipientDOB) return;
    var age = calculateAge(obRecipientDOB);
    addIntakeUserMessage(formatDOB(obRecipientDOB));
    if (age !== null && age < 18) {
      simulateIntakeAITyping(
        "Thank you for sharing that. We're so sorry — Solvyn doesn't yet support caregiving journeys for recipients under 18. We deeply respect what you're doing, and we hope to be able to support you in the future. Please take good care of yourself.",
        function() { setObIntakeStage(99); }
      );
      return;
    }
    simulateIntakeAITyping(
      "What is your relationship to " + obRecipientFirstName.trim() + "?",
      function() { setObIntakeStage(10); }
    );
  }

  function submitRelationship(label) {
    setObRecipientRelationship(label);
    addIntakeUserMessage(label);
    simulateIntakeAITyping(
      "Which income range best describes " + (obRecipientFirstName.trim() || "their") + "'s situation? This helps us identify financial support programs.",
      function() { setObIntakeStage(11); }
    );
  }

  function submitRecipientIncome(bracket) {
    setObRecipientIncome(bracket);
    addIntakeUserMessage(bracket);
    simulateIntakeAITyping(
      "Does " + (obRecipientFirstName.trim() || "your loved one") + " have reliable access to transportation?",
      function() { setObIntakeStage(12); }
    );
  }

  function submitRecipientTransport(val) {
    setObRecipientTransport(val);
    addIntakeUserMessage(val ? "Yes" : "No");
    simulateIntakeAITyping(
      "What languages does " + (obRecipientFirstName.trim() || "your loved one") + " speak? Select all that apply.",
      function() { setObIntakeStage(13); }
    );
  }

  function toggleObLanguage(lang) {
    setObRecipientLanguages(function(prev) {
      return prev.includes(lang) ? prev.filter(function(l) { return l !== lang; }) : [...prev, lang];
    });
  }

  function submitLanguages() {
    var selectedLangs = obRecipientLanguages.filter(function(l) { return l !== "Other"; });
    if (obRecipientLanguages.includes("Other") && obLanguageOtherText.trim()) {
      var otherLangs = obLanguageOtherText.split(",").map(function(l) { return l.trim(); }).filter(function(l) { return l.length > 0; });
      selectedLangs = selectedLangs.concat(otherLangs);
    }
    if (selectedLangs.length === 0) return;
    addIntakeUserMessage(selectedLangs.join(", "));
    simulateIntakeAITyping(
      "Almost done. What types of caregiving are involved for " + (obRecipientFirstName.trim() || "your loved one") + "? This helps me tailor the care journey — select all that apply.",
      function() { setObIntakeStage(14); }
    );
  }

  function toggleObCondition(id) {
    setObRecipientConditions(function(prev) {
      return prev.includes(id) ? prev.filter(function(c) { return c !== id; }) : [...prev, id];
    });
  }

  function submitConditions() {
    if (obRecipientConditions.length === 0) return;
    var condLabels = { cognitive: "Cognitive issues", medical: "Medical needs", social: "Social support & engagement", mobility: "Mobility issues" };
    addIntakeUserMessage(obRecipientConditions.map(function(c) { return condLabels[c]; }).join(", "));
    var rName = obRecipientFirstName.trim() || "your loved one";
    var cName = obCaregiverFirstName.trim() || "you";
    simulateIntakeAITyping(
      "You're almost there, " + cName + ". One last question — what are your goals for " + rName + "? Share as much or as little as you'd like.",
      function() { setObIntakeStage(15); }
    );
  }

  function submitGoals() {
    if (!obGoalsInput.trim()) return;
    var goalText = obGoalsInput.trim();
    addIntakeUserMessage(goalText);
    setObGoalsInput("");
    var rName = obRecipientFirstName.trim() || "your loved one";
    var cName = obCaregiverFirstName.trim() || "you";
    simulateIntakeAITyping(
      "Thank you, " + cName + ". What you're doing for " + rName + " is truly meaningful. Solvyn is now building a personalized caregiving journey for the two of you — one that will continue to evolve as your caregiving needs change.",
      function() { setObIntakeStage(16); }
    );
  }

  function getOnboardingPersonName(rel, sit) {
    var nameMap = { parent: 'Helen', spouse: 'David', child: 'Emma', friend: 'Margaret', multiple: 'Helen' };
    return nameMap[rel] || 'Helen';
  }

  function getOnboardingMessages(rel, sit) {
    var relWord = { parent: 'mom', spouse: 'husband', child: 'son', friend: 'friend', multiple: 'parent' }[rel] || 'mom';
    var n = getOnboardingPersonName(rel, sit);
    var msg1Map = {
      diagnosis: 'My ' + relWord + ' ' + n + ' was just diagnosed with breast cancer. I don\'t know where to start.',
      aging: 'My ' + relWord + ' ' + n + ' is 80 and struggling to live alone. We\'re figuring out next steps.',
      chronic: 'My ' + relWord + ' ' + n + ' has been managing a chronic condition and things are getting harder.',
      recovery: 'My ' + relWord + ' ' + n + ' just had surgery and needs more support during recovery.',
      memory: 'My ' + relWord + ' ' + n + ' was recently diagnosed with early-stage dementia.',
      eol: 'My ' + relWord + ' ' + n + ' is in hospice care and we\'re trying to figure out how to support her.'
    };
    var msg2Map = {
      diagnosis: n + ' is 74, lives alone, and the whole family is scattered across different states.',
      aging: n + ' is 80 and still at home, but struggling with daily tasks. Family is nearby but overwhelmed.',
      chronic: n + ' is 71 and managing multiple conditions. Coordinating her care has become really difficult.',
      recovery: n + ' is 68 and will need at-home care for about 6 weeks. We\'re trying to plan ahead.',
      memory: n + ' is 77, still living at home, but the family disagrees about what to do next.',
      eol: n + ' is 81, in home hospice. We want to make sure her wishes are honored and she\'s comfortable.'
    };
    return {
      msg1: msg1Map[sit] || 'My ' + relWord + ' ' + n + ' needs more support and I\'m not sure where to start.',
      msg2: msg2Map[sit] || n + ' is 74 and lives alone. The whole family is trying to figure out next steps.'
    };
  }

  function getOnboardingRoadmap(personName, situation) {
    var n = personName || 'Eleanor';
    return {
      title: n + '\'s Transition Journey',
      description: 'A complete roadmap for transitioning ' + n + ' from living on her own to assisted living',
      milestones: [
        {
          title: 'Evaluate the needs of our loved one',
          why: 'Before anything else, you need a clear picture of where ' + n + ' is today — what she can do on her own, what has changed, and where the real gaps are. This foundation shapes every decision that comes next.',
          tasks: [
            'Document their activities of daily living (ADLs)',
            'Look for changes in behavior',
            'Identify current challenges that assisted living or nursing care could help with'
          ],
          isPriority: true
        },
        {
          title: 'Identify stakeholders and collaborators',
          why: 'You shouldn\'t have to carry this alone — knowing who is part of ' + n + '\'s circle of support, and what role each person can play, is the first step toward sharing the load.',
          tasks: [
            'Identify family members'
          ],
          isPriority: false
        },
        {
          title: 'Have a conversation with our family and friends',
          why: 'Bringing the people closest to ' + n + ' into alignment early prevents confusion later and ensures everyone is pulling in the same direction when it matters most.',
          tasks: [
            'Identify stakeholders, collaborators, and friends',
            'Host a conversation about transitioning ' + n + ' to assisted living'
          ],
          isPriority: false
        },
        {
          title: 'Have a conversation with your loved one',
          why: 'This is the most important conversation in the journey — ' + n + ' deserves to be heard, involved, and respected throughout this transition, not just informed after decisions have been made.',
          tasks: [
            'Prepare for the conversation',
            'Discuss alternative living situations with ' + n
          ],
          isPriority: false
        },
        {
          title: 'Talk to your employer about caregiving duties',
          why: 'Caregiving has a real impact on your work life, and being proactive with your employer protects both your job and your ability to show up fully for ' + n + ' during this time.',
          tasks: [
            'Prepare conversation with your direct leadership at work',
            'Schedule and have a conversation about your caregiving duties'
          ],
          isPriority: false
        },
        {
          title: 'Evaluate the financial situation of our loved one',
          why: 'Understanding ' + n + '\'s finances and legal protections now prevents costly surprises later and ensures she has the coverage and security she needs going forward.',
          tasks: [
            'Evaluate how finances are currently managed',
            'Inventory key financial documents',
            'Evaluate proper legal protections',
            'Begin to think about future plans'
          ],
          isPriority: false
        },
        {
          title: 'Define budget and evaluate payment options',
          why: 'Knowing what ' + n + '\'s care will cost — and how to pay for it — gives your family the clarity to make confident decisions rather than reactive ones under pressure.',
          tasks: [
            'Evaluate prices for facilities of interest',
            'Layout the options for payment'
          ],
          isPriority: false
        },
        {
          title: 'Evaluate and select a facility',
          why: 'Finding the right place for ' + n + ' means more than comparing prices — it means finding a community where she will feel safe, respected, and at home.',
          tasks: [
            'Review personal criteria and any special needs',
            'Create list of possible facilities',
            'Visit and tour facilities',
            'Compare, prioritize, and select a facility',
            'Discuss logistics with the selected facility'
          ],
          isPriority: false
        },
        {
          title: 'Close the chapter of our current living situation',
          why: 'Wrapping up ' + n + '\'s current home is a meaningful moment — approaching it with care and intention honors the life she built there while making space for what comes next.',
          tasks: [
            'Sell the home',
            'Move out of existing home'
          ],
          isPriority: false
        },
        {
          title: 'Start our new chapter in our new home',
          why: 'Moving day marks the beginning of ' + n + '\'s next chapter — a thoughtful arrival sets the tone for her comfort, dignity, and sense of belonging from day one.',
          tasks: [
            'Discuss required essentials with the new facility',
            'Determine if there are special accommodations you need to provide yourself',
            'Pack clothes and other belongings we are taking to our new home',
            'Move into our new home',
            'Notify key stakeholders and family of the change in address and other new contact info'
          ],
          isPriority: false
        },
        {
          title: 'Transitioning to our new relationship',
          why: 'Your relationship with ' + n + ' does not end here — it evolves, and building new rhythms together in this chapter is how you make sure she still feels loved, connected, and seen.',
          tasks: [
            'Plan meals with ' + n,
            'Meet the other residents',
            'Set up a regular visit cadence',
            'Continue to do activities together that you both enjoy'
          ],
          isPriority: false
        }
      ],
      priorityTasks: [
        'Document ' + n + '\'s activities of daily living (ADLs)',
        'Look for changes in behavior',
        'Identify current challenges that assisted living could help with'
      ]
    };
  }

  function toggleMilestone(milestoneIndex) {
    setExpandedMilestones(function(prev) {
      return {
        ...prev,
        [milestoneIndex]: !prev[milestoneIndex]
      };
    });
  }

  function startDemoMode() {
    setDemoMode(true);
    handleScreenChange('home');
  }

  function exitDemoMode() {
    setDemoMode(false);
    setShowAIChat(false);
    setActiveScenario(null);
    setAiMessages([]);
  }

  function triggerScenario(scenario) {
    console.log('Triggering scenario:', scenario); // Debug log
    setActiveScenario(scenario);
    setShowAIChat(true);
    
    // Pre-populate with scenario-specific messages
    const scenarioMessages = {
      'overdue': [
        { type: 'ai', text: "Hi! I noticed Eleanor's facility tour is 3 days overdue. I know these transitions can be overwhelming. Would you like me to help reschedule it or create a more flexible timeline?" },
        { type: 'user', text: "Yes, help me reschedule it" },
        { type: 'ai', text: "I'd be happy to help! I can create a new task with a more flexible timeline and suggest some local assisted living facilities. Should I proceed with rescheduling?" }
      ],
      'profile': [
        { type: 'ai', text: "I see Eleanor's medication routine changed recently. This often means her care needs are evolving. Would you like me to help update her profile with the new information?" },
        { type: 'user', text: "Yes, please update her profile" },
        { type: 'ai', text: "Perfect! I'll update Eleanor's health conditions and medication schedule. I can also suggest some additional resources based on her current needs. Should I make these updates?" }
      ],
      'progress': [
        { type: 'ai', text: "Great progress on Eleanor's journey! She's completed 3 of 5 milestones. I'm thinking the next step might be scheduling her move-in date. Should I help you plan that timeline?" },
        { type: 'user', text: "Yes, help me plan the timeline" },
        { type: 'ai', text: "Excellent! I can create a detailed move-in timeline with tasks for packing, coordinating with the facility, and family communication. Would you like me to set this up?" }
      ],
      'health': [
        { type: 'ai', text: "I noticed Eleanor's care needs are evolving based on recent changes. Sometimes it helps to check in with family and update her care plan. Would you like me to help coordinate this?" },
        { type: 'user', text: "Yes, help me coordinate" },
        { type: 'ai', text: "I can help you prepare for a family conversation about Eleanor's evolving needs and suggest some local resources. Should I create a plan for this?" }
      ]
    };
    
    setAiMessages(scenarioMessages[scenario] || []);
    console.log('AI chat should be visible now'); // Debug log
  }

  function executeAIAction(scenario) {
    setAiWorking(true);
    setShowAIChat(false);
    
    // Add AI working message
    const workingMessage = { type: 'ai', text: "Let me help you with that..." };
    setAiMessages(prev => [...prev, workingMessage]);
    
    setTimeout(() => {
      switch(scenario) {
        case 'overdue':
          executeOverdueAction();
          break;
        case 'profile':
          executeProfileAction();
          break;
        case 'progress':
          executeProgressAction();
          break;
        case 'health':
          executeHealthAction();
          break;
        default:
          console.log('Unknown scenario:', scenario);
      }
      setAiWorking(false);
    }, 2000);
  }

  function executeOverdueAction() {
    // Create AI-suggested task
    const newTask = {
      id: Date.now(),
      title: "Reschedule Facility Tour - Flexible Timeline",
      status: "To Do",
      aiSuggested: true,
      aiReason: "Based on Eleanor's current timeline constraints",
      dueDate: "Next Friday",
      description: "AI suggested: Create a more flexible timeline for Eleanor's facility tours to reduce stress and accommodate her needs."
    };
    
    setAiTasks(prev => [...prev, newTask]);
    setHighlightedTask(newTask.id);
    
    // Navigate to task detail page
    setCurrentScreen('task-detail');
    
    // Add success message
    const successMessage = { type: 'ai', text: "Perfect! I've created a flexible rescheduling task for Eleanor's facility tour. The new timeline gives you more breathing room while keeping the process moving forward." };
    setAiMessages(prev => [...prev, successMessage]);
  }

  function executeProfileAction() {
    // Navigate to Eleanor's profile
    setCurrentScreen('eleanor-profile');
    setHighlightedFields(['medication', 'healthConditions']);
    
    // Add success message
    const successMessage = { type: 'ai', text: "I've highlighted the areas in Eleanor's profile that need updating based on her recent medication changes. You can review and update these fields with the new information." };
    setAiMessages(prev => [...prev, successMessage]);
  }

  function executeProgressAction() {
    // Create AI-suggested milestone
    const newMilestone = {
      id: Date.now(),
      title: "Schedule Move-in Date",
      aiSuggested: true,
      aiReason: "Next logical step in Eleanor's transition",
      tasks: ["Contact facility for availability", "Coordinate with family", "Plan logistics and timeline"],
      status: "Ready to Start"
    };
    
    setAiMilestones(prev => [...prev, newMilestone]);
    
    // Navigate to journey map
    setCurrentScreen('journey-map');
    
    // Add success message
    const successMessage = { type: 'ai', text: "Excellent! I've added a new milestone 'Schedule Move-in Date' to Eleanor's journey with specific tasks to help coordinate this important step." };
    setAiMessages(prev => [...prev, successMessage]);
  }

  function executeHealthAction() {
    // Create AI-suggested family communication task
    const newTask = {
      id: Date.now(),
      title: "Family Meeting - Eleanor's Evolving Needs",
      status: "To Do",
      aiSuggested: true,
      aiReason: "Coordinate care plan updates with family",
      dueDate: "This week",
      description: "AI prepared: Family discussion about Eleanor's changing care needs, including talking points and local resources."
    };
    
    setAiTasks(prev => [...prev, newTask]);
    setHighlightedTask(newTask.id);
    
    // Navigate to home screen to show the new task
    handleScreenChange('home');
    
    // Add success message
    const successMessage = { type: 'ai', text: "I've created a family meeting task with prepared talking points and local resources. This will help coordinate Eleanor's evolving care needs with your family." };
    setAiMessages(prev => [...prev, successMessage]);
  }

  // Discover page AI engagement functions
  function startDiscoverEngagement() {
    setDiscoverPhase('ai-engagement');
    setDiscoverMessages([]);
    
    // Simulate AI typing
    simulateAITyping("Hi Tess! I see you're exploring different journeys today. What situation would you like guidance with?", () => {
      // Automatically proceed to conversation phase after AI finishes typing
      setTimeout(() => {
        setDiscoverPhase('conversation');
        setShowTypingButton(true);
      }, 1000);
    });
  }


  function simulateTyping() {
    const message = "I need to start evaluating what it will take to get my mother Eleanor into an assisted living facility";
    let index = 0;
    setIsTyping(true);
    setUserInput('');
    setShowTypingButton(false);
    
    const typeInterval = setInterval(() => {
      if (index < message.length) {
        setUserInput(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setIsTyping(false);
      }
    }, 60); // Type each character every 60ms for better readability
  }

  function simulateSecondTyping() {
    const message = "Yes, that would be helpful";
    let index = 0;
    setIsTyping(true);
    setUserInput('');
    setShowTypingButton(false);
    
    const typeInterval = setInterval(() => {
      if (index < message.length) {
        setUserInput(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setIsTyping(false);
      }
    }, 60); // Type each character every 60ms for better readability
  }

  function simulateAITyping(message, callback) {
    let index = 0;
    setDiscoverWorking(true);
    setAiTypingText('');
    
    const typeInterval = setInterval(() => {
      if (index < message.length) {
        setAiTypingText(message.substring(0, index + 1));
        index++;
      } else {
        clearInterval(typeInterval);
        setDiscoverWorking(false);
        
        // Add the final complete message to the messages array
        setDiscoverMessages(prev => [...prev, { type: 'ai', text: message }]);
        
        setAiTypingText('');
        if (callback) callback();
      }
    }, 80); // Same timing as user typing
  }

  function sendSecondMessage() {
    if (userInput.trim()) {
      handleYesResponse();
    }
  }

  function sendMessage() {
    if (userInput.trim()) {
      setDiscoverMessages(prev => [...prev, 
        { type: 'user', text: userInput }
      ]);
      setUserInput('');
      setShowTypingButton(false);
      
      // Simulate AI typing
      simulateAITyping("That's a significant transition that requires careful planning. I can create a personalized approach based on your specific situation. Would you like to see a customized journey for Eleanor's transition?", () => {
        setDiscoverPhase('awaiting-response');
        setShowTypingButton(true);
      });
    }
  }

  function handleYesResponse() {
        setDiscoverMessages(prev => [...prev, 
      { type: 'user', text: userInput }
    ]);
    setUserInput('');
    setShowTypingButton(false);
    
    // Simulate AI typing
    simulateAITyping("Perfect. I'll create a customized journey designed specifically for your situation with Eleanor. This will give you a tailored plan you can follow.", () => {
      // Show spinner for 4 seconds after AI finishes typing
      setDiscoverPhase('searching');
      setTimeout(() => {
        setDiscoverPhase('view-results');
      }, 4000); // 4 second delay
    });
  }

  function viewResults() {
    setDiscoverPhase('results');
  }

  function startHomePrompt() {
    console.log('Starting home prompt');
    setShowHomePrompt(true);
    setHomePromptMessages([
      { type: 'ai', text: "Hi there! I'm Solvyn, your AI care assistant. What can I help you with today?" }
    ]);
  }

  function closeHomePrompt() {
    setShowHomePrompt(false);
    setHomePromptMessages([]);
    setHomePromptInput('');
    setHomePromptWorking(false);
  }

  function sendHomePromptMessage() {
    if (homePromptInput.trim()) {
      setHomePromptMessages(prev => [...prev, 
        { type: 'user', text: homePromptInput }
      ]);
      setHomePromptWorking(true);
      setHomePromptInput('');
      
      // Simulate AI response
      setTimeout(() => {
        setHomePromptMessages(prev => [...prev, 
          { type: 'ai', text: "I understand you're looking for help with that. Let me assist you with some relevant resources and guidance. Is there anything specific you'd like to focus on first?" }
        ]);
        setHomePromptWorking(false);
      }, 1500);
    }
  }

  const TAB_SCREENS = ['home', 'journeys', 'discover', 'account'];
  const ONBOARDING_SCREENS = ['splash', 'signin', 'pulse-check', 'onboarding-welcome', 'onboarding-pulse', 'onboarding-location', 'onboarding-handoff', 'onboarding-chat', 'onboarding-building', 'onboarding-roadmap', 'onboarding-save', 'onboarding-intake', 'onboarding-goals'];

  // Reset discover page when navigating away
  function handleScreenChange(newScreen) {
    if (newScreen !== 'discover') {
      setDiscoverPhase('empty');
      setDiscoverMessages([]);
      setDiscoverWorking(false);
      setUserInput('');
      setIsTyping(false);
      setChatbotManuallyClosed(false);
    }

    // Determine transition direction
    const from = currentScreen;
    const to = newScreen;
    let nextClass = 'screen-fade';
    if (!ONBOARDING_SCREENS.includes(from) && !ONBOARDING_SCREENS.includes(to)) {
      if (TAB_SCREENS.includes(to)) {
        nextClass = 'screen-slide-left';
      } else if (TAB_SCREENS.includes(from)) {
        nextClass = 'screen-slide-right';
      } else {
        nextClass = 'screen-slide-right';
      }
    }
    setTransitionClass(nextClass);
    setCurrentScreen(newScreen);
  }

  function sendAiChatMessage() {
    if (aiChatInput.trim()) {
      // Add user message
      setAiMessages(prev => [...prev, { type: 'user', text: aiChatInput }]);
      setAiChatInput('');
      
      // Simulate AI response
      setAiWorking(true);
      setTimeout(() => {
        const aiResponse = { 
          type: 'ai', 
          text: "I'd be happy to help! Let me provide guidance on that. What specific aspects would you like me to focus on?" 
        };
        setAiMessages(prev => [...prev, aiResponse]);
        setAiWorking(false);
      }, 1000);
    }
  }

  // Start AI engagement when discover page loads
  React.useEffect(() => {
    if (currentScreen === 'discover' && discoverPhase === 'empty' && !chatbotManuallyClosed) {
      setTimeout(() => {
        startDiscoverEngagement();
      }, 500);
    }
  }, [currentScreen, discoverPhase, chatbotManuallyClosed]);

  // Auto-scroll to bottom of chat when messages change or AI is typing
  React.useEffect(() => {
    const chatContainer = document.querySelector('[data-chat-container]');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [discoverMessages, discoverWorking, aiTypingText]);

  // Auto-resize textarea during typing simulation
  React.useEffect(() => {
    const textarea = document.querySelector('textarea[placeholder="Type your message..."]');
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    }
  }, [userInput]);

  // Auto-resize AI typing textarea and ensure scroll follows typing
  React.useEffect(() => {
    const aiTextarea = document.querySelector('textarea[readonly]');
    const chatContainer = document.querySelector('[data-chat-container]');
    
    if (aiTextarea) {
      aiTextarea.style.height = 'auto';
      aiTextarea.style.height = aiTextarea.scrollHeight + 'px'; // No height limit
      
      // Force scroll to bottom to follow typing
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
    }
  }, [aiTypingText]);


  // Auto-scroll to bottom of home prompt chat when messages change
  React.useEffect(() => {
    const homeyChatContainer = document.querySelector('[data-home-chat-container]');
    if (homeyChatContainer) {
      homeyChatContainer.scrollTop = homeyChatContainer.scrollHeight;
    }
  }, [homePromptMessages, homePromptWorking]);

  // Onboarding chat auto-start — Demo_Onboarding_Script_Solvyn
  React.useEffect(() => {
    if (currentScreen === 'onboarding-chat' && onboardingChatStage === 0) {
      setOnboardingChatStage(1);
      setOnboardingPersonName('Eleanor');

      setTimeout(function() {
        // AI 1
        simulateOnboardingAITyping(
          "Hi, I\u2019m Solvyn. Before I build your roadmap, I\u2019d love to learn a little about your situation. You can share as much or as little as you\u2019re comfortable with. What\u2019s your name?",
          function() {
            setOnboardingChatStage(2);
            setTimeout(function() {
              // User 1
              simulateOnboardingUserTyping("I\u2019m Tess.", function() {
                setOnboardingChatStage(3);
                setTimeout(function() {
                  // AI 2
                  simulateOnboardingAITyping("Hi Tess. And who are you caring for?", function() {
                    setOnboardingChatStage(4);
                    setTimeout(function() {
                      // User 2
                      simulateOnboardingUserTyping("My mom, Eleanor. She\u2019s 75.", function() {
                        setOnboardingChatStage(5);
                        setTimeout(function() {
                          // AI 3
                          simulateOnboardingAITyping(
                            "What\u2019s going on with Eleanor right now \u2014 what made you reach out today?",
                            function() {
                              setOnboardingChatStage(6);
                              setTimeout(function() {
                                // User 3
                                simulateOnboardingUserTyping(
                                  "She\u2019s been living alone and it\u2019s not safe anymore. She had a fall a few months ago and I\u2019m constantly checking in on her. We\u2019ve talked as a family and we\u2019ve decided it\u2019s time. We need to start evaluating assisted living options for her.",
                                  function() {
                                    setOnboardingChatStage(7);
                                    setTimeout(function() {
                                      // AI 4
                                      simulateOnboardingAITyping(
                                        "That\u2019s a meaningful decision to arrive at as a family, and it takes real courage to act on it. The fact that you\u2019re here and ready to move forward puts Eleanor in a much better position than most families in this situation.\n\nIs Eleanor on board, or is that still a conversation you\u2019re working through with her?",
                                        function() {
                                          setOnboardingChatStage(8);
                                          setTimeout(function() {
                                            // User 4
                                            simulateOnboardingUserTyping(
                                              "She\u2019d prefer to stay home, but deep down I think she knows things are changing. She doesn\u2019t love talking about it.",
                                              function() {
                                                setOnboardingChatStage(9);
                                                setTimeout(function() {
                                                  // AI 5
                                                  simulateOnboardingAITyping(
                                                    "That\u2019s very common, and it\u2019s something we\u2019ll help you prepare for. One of your first milestones will be having that conversation with Eleanor on her terms.\n\nA couple more things that help me tailor your plan. Where does Eleanor live, and is there anything about her situation you want to make sure we account for? Language, culture, who else is involved \u2014 whatever feels relevant.",
                                                    function() {
                                                      setOnboardingChatStage(10);
                                                      setTimeout(function() {
                                                        // User 5
                                                        simulateOnboardingUserTyping(
                                                          "Eleanor lives in Ludlow. I\u2019m in Boston, but my brother lives nearby in Ludlow too and he helps out when he can. Her English isn\u2019t great. She\u2019s much more comfortable in Portuguese, and her community there really matters to her.",
                                                          function() {
                                                            setOnboardingChatStage(11);
                                                            setTimeout(function() {
                                                              // AI 6 — closing
                                                              simulateOnboardingAITyping(
                                                                "That\u2019s really helpful, Tess. Having your brother close to Eleanor is a real advantage. Your roadmap will reflect how you two can share the responsibilities even with you in Boston. And we\u2019ll make sure Eleanor can move through this transition in her language and close to the community she knows.\n\nI have everything I need. Let me build your roadmap.",
                                                                function() { setOnboardingChatStage(12); }
                                                              );
                                                            }, 1200);
                                                          }
                                                        );
                                                      }, 1800);
                                                    }
                                                  );
                                                }, 1200);
                                              }
                                            );
                                          }, 1800);
                                        }
                                      );
                                    }, 1200);
                                  }
                                );
                              }, 1800);
                            }
                          );
                        }, 1200);
                      });
                    }, 1800);
                  });
                }, 1200);
              });
            }, 1800);
          }
        );
      }, 600);
    }
  }, [currentScreen]);

  // Auto-scroll onboarding chat — also fires on stage change so CTA reveal scrolls properly
  React.useEffect(() => {
    setTimeout(function() {
      var container = document.querySelector('[data-onboarding-chat]');
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }, [onboardingChatMessages, onboardingAITyping, onboardingAITypingText, onboardingUserTyping, onboardingUserTypingText, onboardingChatStage]);

  // Intake screen auto-start
  React.useEffect(() => {
    if (currentScreen === "onboarding-intake" && obIntakeStage === 0 && obIntakeMessages.length === 0) {
      setTimeout(function() {
        simulateIntakeAITyping(
          "To build your personalized caregiving roadmap, I'd love to learn a bit about you and the person you're caring for. Let's start with how you're feeling right now — there's no right answer, this just helps me understand where you're coming from.",
          function() { setObIntakeStage(1); }
        );
      }, 400);
    }
  }, [currentScreen]);

  // Auto-scroll intake chat
  React.useEffect(() => {
    setTimeout(function() {
      var container = document.querySelector('[data-intake-chat]');
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }, [obIntakeMessages, obIntakeAITyping, obIntakeAITypingText, obIntakeStage]);

  // Goals screen auto-start
  React.useEffect(() => {
    if (currentScreen === 'onboarding-goals' && obGoalsStage === 0 && obGoalsMessages.length === 0) {
      setTimeout(function() {
        var rName = obRecipientFirstName.trim() || 'your loved one';
        var cName = obCaregiverFirstName.trim() || 'there';
        simulateGoalsAITyping(
          "You're almost there, " + cName + ". One last question — what are your goals for " + rName + "? Share as much or as little as you'd like.",
          function() { setObGoalsStage(2); }
        );
      }, 400);
    }
  }, [currentScreen]);

  // Auto-scroll goals chat
  React.useEffect(() => {
    setTimeout(function() {
      var container = document.querySelector('[data-goals-chat]');
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }, [obGoalsMessages, obGoalsAITyping, obGoalsAITypingText, obGoalsStage]);

  // Building screen — auto-step through status messages then navigate to home
  React.useEffect(() => {
    if (currentScreen !== 'onboarding-building') return;
    setOnboardingBuildingStep(0);
    var t1 = setTimeout(function() { setOnboardingBuildingStep(1); }, 800);
    var t2 = setTimeout(function() { setOnboardingBuildingStep(2); }, 1700);
    var t3 = setTimeout(function() { setOnboardingBuildingStep(3); }, 2600);
    var t4 = setTimeout(function() { setOnboardingBuildingStep(4); }, 3400);
    var t5 = setTimeout(function() { handleScreenChange('home'); }, 4400);
    return function() { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); clearTimeout(t5); };
  }, [currentScreen]);

  function renderScreen() {
    if (currentScreen === 'splash') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: 'linear-gradient(180deg, #EAF4F7 0%, #FDFCFC 55%)' }}>
          {/* Brand section */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 32px' }}>
            <div style={{ width: '72px', height: '72px', borderRadius: '20px', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', boxShadow: '0 8px 24px rgba(74, 144, 164, 0.3)' }}>
              <span style={{ fontSize: '32px', fontWeight: '700', color: 'white', letterSpacing: '-1px' }}>S</span>
            </div>
            <h1 style={{ fontSize: '42px', fontWeight: '700', color: '#1a2e35', marginBottom: '12px', letterSpacing: '-1px' }}>solvyn</h1>
            <p style={{ fontSize: '17px', color: '#5a7a85', textAlign: 'center', lineHeight: '1.5', maxWidth: '260px', margin: '0' }}>Know exactly what to do next — step by step.</p>
          </div>

          {/* CTA section */}
          <div style={{ padding: '0 28px 56px' }}>
            <button
              onClick={function() { startOnboarding(); }}
              style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px 24px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', marginBottom: '12px', boxShadow: '0 4px 16px rgba(74, 144, 164, 0.35)', letterSpacing: '-0.2px' }}
            >
              Get Started
            </button>

            <button
              onClick={function() { setCurrentScreen('signin'); }}
              style={{ width: '100%', background: 'transparent', border: '1.5px solid rgba(74, 144, 164, 0.35)', color: '#4A90A4', padding: '17px 24px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px' }}
            >
              Log In
            </button>
          </div>
        </div>
      );
    }

    if (currentScreen === 'signin') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          <div style={{ flex: 1, padding: '48px 32px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '32px' }}>
            <button onClick={function() { setCurrentScreen('pulse-check'); }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '18px 20px', borderRadius: '12px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', background: '#ffffff', color: '#333', border: '2px solid rgba(74, 144, 164, 0.15)' }}>
              Continue with Google
            </button>
            <div style={{ height: '1px', background: 'rgba(74, 144, 164, 0.2)' }}></div>
            <input type="text" placeholder="Email or phone number" style={{ width: '100%', padding: '18px 20px', border: '2px solid rgba(74, 144, 164, 0.2)', borderRadius: '12px', fontSize: '16px', background: '#FFFFFF', color: '#4A90A4', minHeight: '56px' }} />
            <button onClick={function() { setCurrentScreen('pulse-check'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', color: 'white', border: 'none', padding: '18px 24px', borderRadius: '12px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', minHeight: '56px' }}>
              Send Login Link
            </button>
          </div>
        </div>
      );
    }

    if (currentScreen === 'pulse-check') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          <div style={{ textAlign: 'center', padding: '24px 32px' }}>
            <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#4A90A4', marginBottom: '8px' }}>How are you feeling today?</h1>
            <p style={{ fontSize: '16px', color: '#8B5A73' }}>This helps us personalize your experience</p>
          </div>
          <div style={{ flex: 1, minHeight: 0, padding: '0 24px 24px', display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto' }}>
            <button onClick={function() { setPulseState('great'); handleScreenChange('home'); }} style={{ background: '#F8F6F6', border: '2px solid transparent', borderRadius: '12px', padding: '16px', textAlign: 'left', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(74, 144, 164, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>😊</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#4A90A4', marginBottom: '2px' }}>Great</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Energized; ready for challenges</div>
                </div>
              </div>
            </button>
            <button onClick={function() { setPulseState('steady'); handleScreenChange('home'); }} style={{ background: '#F8F6F6', border: '2px solid transparent', borderRadius: '12px', padding: '16px', textAlign: 'left', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(74, 144, 164, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>😌</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#4A90A4', marginBottom: '2px' }}>Steady</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Managing well; normal load</div>
                </div>
              </div>
            </button>
            <button onClick={function() { setPulseState('strained'); handleScreenChange('home'); }} style={{ background: '#F8F6F6', border: '2px solid transparent', borderRadius: '12px', padding: '16px', textAlign: 'left', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(74, 144, 164, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>😐</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#4A90A4', marginBottom: '2px' }}>Strained</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Reduced capacity; could use support</div>
                </div>
              </div>
            </button>
            <button onClick={function() { setPulseState('overwhelmed'); handleScreenChange('home'); }} style={{ background: '#F8F6F6', border: '2px solid transparent', borderRadius: '12px', padding: '16px', textAlign: 'left', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: 'rgba(74, 144, 164, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>😰</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#4A90A4', marginBottom: '2px' }}>Overwhelmed</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Need relief/assistance now</div>
                </div>
              </div>
            </button>
          </div>
        </div>
      );
    }

    // ─── ONBOARDING FLOW ────────────────────────────────────────────────────────

    // Inline helpers used across onboarding screens
    var obProgressBar = function(step) {
      return (
        <div style={{ height: '4px', background: '#EBEBEB', borderRadius: '4px', overflow: 'hidden', flex: 1, margin: '0 16px' }}>
          <div style={{ height: '100%', width: Math.round((step / 4) * 100) + '%', background: 'linear-gradient(90deg, #4A90A4 0%, #357A8A 100%)', borderRadius: '4px', transition: 'width 500ms cubic-bezier(0.4,0,0.2,1)' }} />
        </div>
      );
    };

    var obHeader = function(step, backScreen) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', padding: '20px 20px 16px', flexShrink: 0 }}>
          <button onClick={function() { handleScreenChange(backScreen); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', margin: '-8px', color: '#6b7a80', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <ChevronLeftIcon size={22} />
          </button>
          {obProgressBar(step)}
          <div style={{ width: 38, flexShrink: 0 }} />
        </div>
      );
    };

    // ── Screen 1 of 4: Welcome ──────────────────────────────────────────────────
    if (currentScreen === 'onboarding-welcome') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 28px' }}>
            {/* Brand mark */}
            <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '28px', boxShadow: '0 6px 20px rgba(74,144,164,0.28)' }}>
              <span style={{ fontSize: '26px', fontWeight: '700', color: 'white', letterSpacing: '-1px' }}>S</span>
            </div>
            <h1 style={{ fontSize: '30px', fontWeight: '700', color: '#1A1A1A', marginBottom: '14px', letterSpacing: '-0.8px', lineHeight: '1.25' }}>You're doing something hard. Let's make it a little easier.</h1>
            <p style={{ fontSize: '17px', color: '#666', lineHeight: '1.65', margin: 0 }}>Solvyn will build you a personalized roadmap for your situation. We'll start with just a couple of questions — share only what feels comfortable.</p>
          </div>
          <div style={{ padding: '0 24px 48px', flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('onboarding-intake'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 16px rgba(74,144,164,0.3)' }}>
              Get started
            </button>
          </div>
        </div>
      );
    }

    // ── Screen 2 of 4: Pulse Check ──────────────────────────────────────────────
    if (currentScreen === 'onboarding-pulse') {
      var pulseOptions = [
        { id: 'ready', label: 'Ready to plan and take action' },
        { id: 'anxious', label: 'Anxious but determined to move forward' },
        { id: 'holding', label: 'Holding it together, mostly' },
        { id: 'overwhelmed', label: 'Overwhelmed and not sure where to start' },
        { id: 'exhausted', label: 'Exhausted and running on empty' },
      ];
      var pulseMap = { ready: "great", anxious: "strained", holding: "steady", overwhelmed: "overwhelmed", exhausted: "overwhelmed" };
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          {obHeader(2, 'onboarding-welcome')}
          <div style={{ flex: 1, overflowY: 'auto', padding: '4px 24px 32px' }}>
            <h2 style={{ fontSize: '26px', fontWeight: '700', color: '#1A1A1A', marginBottom: '8px', letterSpacing: '-0.5px', lineHeight: '1.3' }}>How are you feeling right now?</h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '28px', lineHeight: '1.5' }}>There's no right answer. This helps us meet you where you are.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {pulseOptions.map(function(p) {
                return (
                  <button
                    key={p.id}
                    onClick={function() {
                      setPulseState(pulseMap[p.id]);
                      setOnboardingConcern(p.id);
                      handleScreenChange('onboarding-intake');
                    }}
                    style={{ width: '100%', padding: '18px 20px', background: '#FFFFFF', border: '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '16px', fontWeight: '500', color: '#1A1A1A', cursor: 'pointer', textAlign: 'left', lineHeight: '1.4', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', transition: 'all 150ms ease' }}
                  >
                    {p.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      );
    }

    // ── Screen 3 of 4: Location ─────────────────────────────────────────────────
    if (currentScreen === 'onboarding-location') {
      var zipValid = onboardingZip.length === 5 && /^\d{5}$/.test(onboardingZip);
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          {obHeader(3, 'onboarding-pulse')}
          <div style={{ flex: 1, overflowY: 'auto', padding: '4px 24px 100px' }}>
            <h2 style={{ fontSize: '26px', fontWeight: '700', color: '#1A1A1A', marginBottom: '8px', letterSpacing: '-0.5px', lineHeight: '1.3' }}>Where are you located?</h2>
            <p style={{ fontSize: '16px', color: '#666', marginBottom: '32px', lineHeight: '1.5' }}>We use this to find local resources and services in your area.</p>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={5}
              placeholder="ZIP code"
              value={onboardingZip}
              onChange={function(e) { var val = e.target.value.replace(/\D/g, ''); setOnboardingZip(val); }}
              style={{ width: '100%', padding: '18px 20px', border: '2px solid ' + (zipValid ? '#4A90A4' : '#EBEBEB'), borderRadius: '14px', fontSize: '28px', fontWeight: '600', color: '#1A1A1A', background: 'white', letterSpacing: '6px', textAlign: 'center', outline: 'none', boxSizing: 'border-box', transition: 'border-color 200ms ease', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}
              autoFocus
            />
            <p style={{ fontSize: '13px', color: '#B0BEC5', marginTop: '12px', textAlign: 'center' }}>Your location is never shared without your permission.</p>
          </div>
          {zipValid && (
            <div className="fade-up-in" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '16px 24px 36px', background: '#FFFFFF', borderTop: '1px solid #F0EEEE', boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}>
              <button onClick={function() { handleScreenChange('onboarding-handoff'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px' }}>
                Continue
              </button>
            </div>
          )}
        </div>
      );
    }

    // ── Screen 4 of 4: Handoff to AI ────────────────────────────────────────────
    if (currentScreen === 'onboarding-handoff') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          {obHeader(4, 'onboarding-location')}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 28px' }}>
            {/* Solvyn avatar */}
            <div style={{ width: '64px', height: '64px', borderRadius: '20px', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '28px', boxShadow: '0 8px 24px rgba(74,144,164,0.25)' }}>
              <span style={{ fontSize: '28px', fontWeight: '700', color: 'white', letterSpacing: '-1px' }}>S</span>
            </div>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1A1A1A', marginBottom: '14px', letterSpacing: '-0.6px', lineHeight: '1.25' }}>Let's talk through the rest together.</h2>
            <p style={{ fontSize: '17px', color: '#666', lineHeight: '1.65', margin: 0 }}>Solvyn will ask you a few more questions in its own words. Take your time — there's no rush.</p>
          </div>
          <div style={{ padding: '0 24px 48px', flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('onboarding-chat'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 16px rgba(74,144,164,0.3)' }}>
              Talk to Solvyn
            </button>
          </div>
        </div>
      );
    }

    // ── Intake Screen (Phase 1 + 2) ─────────────────────────────────────────────
    if (currentScreen === 'onboarding-intake') {
      var incomeBrackets = ['Under $25,000', '$25,000 – $49,999', '$50,000 – $74,999', '$75,000 – $99,999', '$100,000 – $149,999', '$150,000+', 'Prefer not to say'];
      var languagesList = ['English','Spanish','Mandarin','Cantonese','French','Portuguese','Arabic','Hindi','Bengali','Russian','Japanese','Korean','Vietnamese','Tagalog','Haitian Creole','Polish','Italian','German','Urdu','Farsi/Persian','Greek','Somali','Amharic','Hmong','Swahili','Hebrew','Yoruba','Igbo','Other'];
      var relationshipOptions = [{id:'parent',label:'Parent'},{id:'spouse',label:'Spouse / Partner'},{id:'sibling',label:'Sibling'},{id:'grandparent',label:'Grandparent'},{id:'child',label:'Child'},{id:'friend',label:'Friend'},{id:'other',label:'Other'}];
      var obConditionsList = [
        { id: 'cognitive', label: 'Cognitive issues', desc: 'Memory, dementia, confusion' },
        { id: 'medical', label: 'Medical needs', desc: 'Chronic conditions, medications' },
        { id: 'social', label: 'Social support & engagement', desc: 'Isolation, companionship' },
        { id: 'mobility', label: 'Mobility issues', desc: 'Movement, fall risk, assistance' }
      ];
      var zipValid = onboardingZip.length === 5 && /^\d{5}$/.test(onboardingZip);
      var caregiverDOBAge = calculateAge(obCaregiverDOB);
      var caregiverDOBUnder18 = obCaregiverDOB && caregiverDOBAge !== null && caregiverDOBAge < 18;
      var caregiverNameValid = obCaregiverFirstName.trim().length > 0 && obCaregiverLastName.trim().length > 0;
      var recipientNameValid = obRecipientFirstName.trim().length > 0 && obRecipientLastName.trim().length > 0;

      var btnStyle = { width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 16px rgba(74,144,164,0.3)', marginTop: '12px' };
      var inputStyle = { width: '100%', padding: '16px 18px', border: '2px solid #EBEBEB', borderRadius: '14px', fontSize: '16px', background: 'white', outline: 'none', boxSizing: 'border-box', color: '#1A1A1A', transition: 'border-color 200ms ease', fontFamily: 'inherit' };
      var yesNoBtn = function(label, onClick, selected) { return <button onClick={onClick} style={{ flex: 1, padding: '18px', background: selected ? 'linear-gradient(135deg,#4A90A4,#357A8A)' : '#FFFFFF', color: selected ? 'white' : '#1A1A1A', border: selected ? 'none' : '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>{label}</button>; };
      var intakePulseOptions = [
        { id: 'ready', label: 'Ready to plan and take action' },
        { id: 'anxious', label: 'Anxious but determined to move forward' },
        { id: 'holding', label: 'Holding it together, mostly' },
        { id: 'overwhelmed', label: 'Overwhelmed and not sure where to start' },
        { id: 'exhausted', label: 'Exhausted and running on empty' },
      ];

      function renderIntakeInput() {
        if (obIntakeAITyping) return (
          <div style={{ padding: '10px 0 2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A90A4', animation: 'obPulseRing 1.2s ease-out infinite' }} />
            <span style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500' }}>Solvyn is thinking…</span>
          </div>
        );

        // Stage 1 — Pulse check (inline, exactly as today)
        if (obIntakeStage === 1) return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {intakePulseOptions.map(function(p) {
              return (
                <button key={p.id} onClick={function(){submitPulseChoice(p.id, p.label);}} style={{ width: '100%', padding: '18px 20px', background: '#FFFFFF', border: '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '16px', fontWeight: '500', color: '#1A1A1A', cursor: 'pointer', textAlign: 'left', lineHeight: '1.4', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                  {p.label}
                </button>
              );
            })}
          </div>
        );

        // Stage 2 — ZIP
        if (obIntakeStage === 2) return (
          <div>
            <input type="tel" inputMode="numeric" pattern="[0-9]*" maxLength={5} placeholder="ZIP code" value={onboardingZip} onChange={function(e) { setOnboardingZip(e.target.value.replace(/\D/g,'')); }} style={Object.assign({}, inputStyle, { fontSize: '28px', fontWeight: '600', letterSpacing: '6px', textAlign: 'center', border: '2px solid ' + (zipValid ? '#4A90A4' : '#EBEBEB') })} autoFocus onFocus={function(e){e.target.style.borderColor='#4A90A4';}} onBlur={function(e){if(!zipValid)e.target.style.borderColor='#EBEBEB';}} />
            <p style={{ fontSize: '13px', color: '#B0BEC5', textAlign: 'center', margin: '10px 0 0' }}>Your location is never shared without permission.</p>
            {zipValid && <button onClick={submitZip} style={btnStyle}>Continue</button>}
          </div>
        );

        // Stage 3 — Caregiver name
        if (obIntakeStage === 3) return (
          <div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input placeholder="First name" value={obCaregiverFirstName} onChange={function(e){setObCaregiverFirstName(e.target.value);}} style={Object.assign({}, inputStyle, { flex: 1 })} autoFocus onFocus={function(e){e.target.style.borderColor='#4A90A4';}} onBlur={function(e){e.target.style.borderColor='#EBEBEB';}} />
              <input placeholder="Last name" value={obCaregiverLastName} onChange={function(e){setObCaregiverLastName(e.target.value);}} style={Object.assign({}, inputStyle, { flex: 1 })} onFocus={function(e){e.target.style.borderColor='#4A90A4';}} onBlur={function(e){e.target.style.borderColor='#EBEBEB';}} />
            </div>
            {caregiverNameValid && <button onClick={submitCaregiverName} style={btnStyle}>Continue</button>}
          </div>
        );

        // Stage 4 — Caregiver DOB
        if (obIntakeStage === 4) {
          var maxDate = new Date(); maxDate.setFullYear(maxDate.getFullYear() - 18);
          return (
            <div>
              <input type="date" value={obCaregiverDOB} onChange={function(e){setObCaregiverDOB(e.target.value);}} max={maxDate.toISOString().split('T')[0]} style={Object.assign({}, inputStyle, { border: '2px solid ' + (caregiverDOBUnder18 ? '#E57373' : obCaregiverDOB ? '#4A90A4' : '#EBEBEB') })} onFocus={function(e){e.target.style.borderColor='#4A90A4';}} />
              {caregiverDOBUnder18 && <p style={{ fontSize: '14px', color: '#E57373', marginTop: '8px', fontWeight: '500' }}>You must be 18 or older to use Solvyn.</p>}
              {obCaregiverDOB && !caregiverDOBUnder18 && <button onClick={submitCaregiverDOB} style={btnStyle}>Continue</button>}
            </div>
          );
        }

        // Stage 5 — Caregiver income
        if (obIntakeStage === 5) return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '280px', overflowY: 'auto' }}>
            {incomeBrackets.map(function(b) { return <button key={b} onClick={function(){submitCaregiverIncome(b);}} style={{ padding: '16px 18px', background: '#FFFFFF', border: '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', fontWeight: '500', color: '#1A1A1A', cursor: 'pointer', textAlign: 'left', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>{b}</button>; })}
          </div>
        );

        // Stage 6 — Caregiver transport
        if (obIntakeStage === 6) return (
          <div style={{ display: 'flex', gap: '12px' }}>
            {yesNoBtn('Yes', function(){submitCaregiverTransport(true);}, obCaregiverTransport === true)}
            {yesNoBtn('No', function(){submitCaregiverTransport(false);}, obCaregiverTransport === false)}
          </div>
        );

        // Stage 7 — Family involved
        if (obIntakeStage === 7) return (
          <div style={{ display: 'flex', gap: '12px' }}>
            {yesNoBtn('Yes', function(){submitFamilyInvolved(true);}, obFamilyInvolved === true)}
            {yesNoBtn('No', function(){submitFamilyInvolved(false);}, obFamilyInvolved === false)}
          </div>
        );

        // Stage 8 — Recipient name
        if (obIntakeStage === 8) return (
          <div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input placeholder="First name" value={obRecipientFirstName} onChange={function(e){setObRecipientFirstName(e.target.value);}} style={Object.assign({}, inputStyle, { flex: 1 })} autoFocus onFocus={function(e){e.target.style.borderColor='#4A90A4';}} onBlur={function(e){e.target.style.borderColor='#EBEBEB';}} />
              <input placeholder="Last name" value={obRecipientLastName} onChange={function(e){setObRecipientLastName(e.target.value);}} style={Object.assign({}, inputStyle, { flex: 1 })} onFocus={function(e){e.target.style.borderColor='#4A90A4';}} onBlur={function(e){e.target.style.borderColor='#EBEBEB';}} />
            </div>
            {recipientNameValid && <button onClick={submitRecipientName} style={btnStyle}>Continue</button>}
          </div>
        );

        // Stage 9 — Recipient DOB
        if (obIntakeStage === 9) return (
          <div>
            <input type="date" value={obRecipientDOB} onChange={function(e){setObRecipientDOB(e.target.value);}} style={Object.assign({}, inputStyle, { border: '2px solid ' + (obRecipientDOB ? '#4A90A4' : '#EBEBEB') })} onFocus={function(e){e.target.style.borderColor='#4A90A4';}} />
            {obRecipientDOB && <button onClick={submitRecipientDOB} style={btnStyle}>Continue</button>}
          </div>
        );

        // Stage 10 — Relationship
        if (obIntakeStage === 10) return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {relationshipOptions.map(function(r) { return <button key={r.id} onClick={function(){submitRelationship(r.label);}} style={{ padding: '16px 18px', background: obRecipientRelationship === r.label ? 'linear-gradient(135deg,#4A90A4,#357A8A)' : '#FFFFFF', color: obRecipientRelationship === r.label ? 'white' : '#1A1A1A', border: obRecipientRelationship === r.label ? 'none' : '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', textAlign: 'left', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>{r.label}</button>; })}
          </div>
        );

        // Stage 11 — Recipient income
        if (obIntakeStage === 11) return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '280px', overflowY: 'auto' }}>
            {incomeBrackets.map(function(b) { return <button key={b} onClick={function(){submitRecipientIncome(b);}} style={{ padding: '16px 18px', background: obRecipientIncome === b ? 'linear-gradient(135deg,#4A90A4,#357A8A)' : '#FFFFFF', color: obRecipientIncome === b ? 'white' : '#1A1A1A', border: obRecipientIncome === b ? 'none' : '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', textAlign: 'left', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>{b}</button>; })}
          </div>
        );

        // Stage 12 — Recipient transport
        if (obIntakeStage === 12) return (
          <div style={{ display: 'flex', gap: '12px' }}>
            {yesNoBtn('Yes', function(){submitRecipientTransport(true);}, obRecipientTransport === true)}
            {yesNoBtn('No', function(){submitRecipientTransport(false);}, obRecipientTransport === false)}
          </div>
        );

        // Stage 13 — Languages multi-select with Other text input
        if (obIntakeStage === 13) {
          var otherSelected = obRecipientLanguages.includes('Other');
          var hasValidLangs = obRecipientLanguages.filter(function(l){return l!=='Other';}).length > 0 || (otherSelected && obLanguageOtherText.trim().length > 0);
          return (
            <div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxHeight: '160px', overflowY: 'auto', marginBottom: '10px' }}>
                {languagesList.map(function(lang) {
                  var sel = obRecipientLanguages.includes(lang);
                  return <button key={lang} onClick={function(){toggleObLanguage(lang);}} style={{ padding: '10px 16px', background: sel ? '#4A90A4' : '#F0F4F6', color: sel ? 'white' : '#1A1A1A', border: 'none', borderRadius: '20px', fontSize: '14px', fontWeight: sel ? '600' : '400', cursor: 'pointer', transition: 'all 150ms ease' }}>{lang}</button>;
                })}
              </div>
              {otherSelected && (
                <input
                  type="text"
                  placeholder="e.g. Wolof, Tigrinya, Twi"
                  value={obLanguageOtherText}
                  onChange={function(e){setObLanguageOtherText(e.target.value);}}
                  style={Object.assign({}, inputStyle, { marginBottom: '10px', fontSize: '15px' })}
                  onFocus={function(e){e.target.style.borderColor='#4A90A4';}}
                  onBlur={function(e){e.target.style.borderColor='#EBEBEB';}}
                />
              )}
              {hasValidLangs && <button onClick={submitLanguages} style={btnStyle}>Continue</button>}
            </div>
          );
        }

        // Stage 14 — Conditions multi-select
        if (obIntakeStage === 14) return (
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '10px' }}>
              {obConditionsList.map(function(c) {
                var sel = obRecipientConditions.includes(c.id);
                return (
                  <button key={c.id} onClick={function(){toggleObCondition(c.id);}} style={{ padding: '14px 18px', background: sel ? 'linear-gradient(135deg,#4A90A4,#357A8A)' : '#FFFFFF', color: sel ? 'white' : '#1A1A1A', border: sel ? 'none' : '1.5px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', textAlign: 'left', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                    <div style={{ fontWeight: '600', marginBottom: '2px' }}>{c.label}</div>
                    <div style={{ fontSize: '12px', opacity: sel ? 0.85 : 0.6 }}>{c.desc}</div>
                  </button>
                );
              })}
            </div>
            {obRecipientConditions.length > 0 && <button onClick={submitConditions} style={btnStyle}>Continue</button>}
          </div>
        );

        // Stage 15 — Goals (embedded, free text)
        if (obIntakeStage === 15) return (
          <div>
            <textarea
              value={obGoalsInput}
              onChange={function(e){setObGoalsInput(e.target.value);}}
              placeholder={'Share your hopes and goals for ' + (obRecipientFirstName.trim() || 'your loved one') + '…'}
              rows={3}
              style={{ width: '100%', padding: '14px 16px', border: '2px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', lineHeight: '1.55', resize: 'none', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#1A1A1A', transition: 'border-color 200ms ease' }}
              onFocus={function(e){e.target.style.borderColor='#4A90A4';}}
              onBlur={function(e){e.target.style.borderColor='#EBEBEB';}}
            />
            {obGoalsInput.trim() && <button onClick={submitGoals} style={btnStyle}>Share my goals</button>}
          </div>
        );

        // Stage 16 — Completion CTA
        if (obIntakeStage === 16) return (
          <button onClick={function(){handleScreenChange('onboarding-building');}} style={btnStyle}>
            {"Begin " + (obRecipientFirstName.trim() || "your") + "'s journey →"}
          </button>
        );

        // Stage 99 — Graceful exit (recipient under 18)
        if (obIntakeStage === 99) return (
          <button onClick={function(){handleScreenChange('splash');}} style={Object.assign({}, btnStyle, { background: '#8B5A73', boxShadow: '0 4px 12px rgba(139,90,115,0.25)' })}>
            Return to home
          </button>
        );

        return null;
      }

      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#F5F7F8' }}>
          {obHeader(2, 'onboarding-welcome')}
          {/* Chat area */}
          <div data-intake-chat style={{ flex: 1, overflowY: 'auto', padding: '8px 20px 8px' }}>
            {obIntakeMessages.map(function(msg, i) {
              var isAI = msg.type === 'ai';
              return (
                <div key={i} style={{ display: 'flex', justifyContent: isAI ? 'flex-start' : 'flex-end', marginBottom: '14px' }}>
                  <div style={{ maxWidth: '82%', padding: '12px 16px', borderRadius: isAI ? '4px 16px 16px 16px' : '16px 4px 16px 16px', background: isAI ? '#FFFFFF' : '#4A90A4', color: isAI ? '#1a1a1a' : 'white', fontSize: '15px', lineHeight: '1.6', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', whiteSpace: 'pre-line' }}>
                    {msg.text}
                  </div>
                </div>
              );
            })}
            {obIntakeAITyping && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '14px' }}>
                <div style={{ maxWidth: '82%', minWidth: '56px', padding: '12px 16px', borderRadius: '4px 16px 16px 16px', background: '#FFFFFF', color: '#1a1a1a', fontSize: '15px', lineHeight: '1.6', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                  {obIntakeAITypingText || <span style={{ opacity: 0.4 }}>•••</span>}
                  {obIntakeAITypingText && <span style={{ animation: 'blink 1s step-end infinite' }}>|</span>}
                </div>
              </div>
            )}
            <div style={{ height: '16px' }} />
          </div>
          {/* Input panel */}
          <div style={{ flexShrink: 0, padding: '16px 20px 40px', background: '#FFFFFF', borderTop: '1px solid #F0EEEE', boxShadow: '0 -4px 20px rgba(0,0,0,0.07)' }}>
            {renderIntakeInput()}
          </div>
        </div>
      );
    }

    // ── Goals Screen (Phase 3) ───────────────────────────────────────────────────
    if (currentScreen === 'onboarding-goals') {
      var goalsRName = obRecipientFirstName.trim() || 'your loved one';

      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#F5F7F8' }}>
          {obHeader(4, 'onboarding-intake')}
          {/* Chat area */}
          <div data-goals-chat style={{ flex: 1, overflowY: 'auto', padding: '8px 20px 8px' }}>
            {obGoalsMessages.map(function(msg, i) {
              var isAI = msg.type === 'ai';
              return (
                <div key={i} style={{ display: 'flex', justifyContent: isAI ? 'flex-start' : 'flex-end', marginBottom: '14px' }}>
                  <div style={{ maxWidth: '82%', padding: '12px 16px', borderRadius: isAI ? '4px 16px 16px 16px' : '16px 4px 16px 16px', background: isAI ? '#FFFFFF' : '#4A90A4', color: isAI ? '#1a1a1a' : 'white', fontSize: '15px', lineHeight: '1.6', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', whiteSpace: 'pre-line' }}>
                    {msg.text}
                  </div>
                </div>
              );
            })}
            {obGoalsAITyping && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '14px' }}>
                <div style={{ maxWidth: '82%', minWidth: '56px', padding: '12px 16px', borderRadius: '4px 16px 16px 16px', background: '#FFFFFF', color: '#1a1a1a', fontSize: '15px', lineHeight: '1.6', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
                  {obGoalsAITypingText || <span style={{ opacity: 0.4 }}>•••</span>}
                  {obGoalsAITypingText && <span style={{ animation: 'blink 1s step-end infinite' }}>|</span>}
                </div>
              </div>
            )}
            <div style={{ height: obGoalsStage === 4 ? '120px' : '16px' }} />
          </div>
          {/* Input panel */}
          <div style={{ flexShrink: 0, padding: '16px 20px 40px', background: '#FFFFFF', borderTop: '1px solid #F0EEEE', boxShadow: '0 -4px 20px rgba(0,0,0,0.07)' }}>
            {obGoalsStage === 2 && !obGoalsAITyping && (
              <div>
                <textarea
                  value={obGoalsInput}
                  onChange={function(e) { setObGoalsInput(e.target.value); }}
                  placeholder={'Share your hopes and goals for ' + goalsRName + '…'}
                  rows={3}
                  style={{ width: '100%', padding: '14px 16px', border: '2px solid #EBEBEB', borderRadius: '14px', fontSize: '15px', lineHeight: '1.55', resize: 'none', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', color: '#1A1A1A', transition: 'border-color 200ms ease' }}
                  onFocus={function(e) { e.target.style.borderColor = '#4A90A4'; }}
                  onBlur={function(e) { e.target.style.borderColor = '#EBEBEB'; }}
                />
                {obGoalsInput.trim() && (
                  <button onClick={submitGoals} style={{ width: '100%', marginTop: '10px', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 16px rgba(74,144,164,0.3)' }}>
                    Share my goals
                  </button>
                )}
              </div>
            )}
            {obGoalsStage === 4 && (
              <button onClick={function() { handleScreenChange('onboarding-building'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 16px rgba(74,144,164,0.3)' }}>
            {'Begin ' + goalsRName + "'s journey →"}
              </button>
            )}
          </div>
        </div>
      );
    }

    // ── AI Chat (Simulated) ──────────────────────────────────────────────────────
    if (currentScreen === 'onboarding-chat') {
      var n = onboardingPersonName || 'Eleanor';
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#f5f5f5' }}>
          {/* Header */}
          <div style={{ padding: '20px 24px 16px', flexShrink: 0, borderBottom: '1px solid #EBEBEB', background: 'white' }}>
            <div style={{ fontSize: '17px', fontWeight: '700', color: '#1a1a1a', marginBottom: '2px', letterSpacing: '-0.3px' }}>Ask Solvyn</div>
            <div style={{ fontSize: '13px', color: '#4A90A4', fontWeight: '500' }}>Your Navigation Guide</div>
          </div>

          {/* Chat scroll area — extra bottom padding ensures last bubble is never hidden under the CTA */}
          <div data-onboarding-chat style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 0' }}>
            {onboardingChatMessages.map(function(msg, i) {
              var isAI = msg.type === 'ai';
              return (
                <div key={i} style={{ display: 'flex', justifyContent: isAI ? 'flex-start' : 'flex-end', marginBottom: '16px' }}>
                  <div style={{ maxWidth: '80%', padding: '12px 16px', borderRadius: isAI ? '4px 16px 16px 16px' : '16px 4px 16px 16px', background: isAI ? '#F0F0F0' : '#4A90A4', color: isAI ? '#1a1a1a' : 'white', fontSize: '15px', lineHeight: '1.55', wordBreak: 'break-word' }}>
                    {msg.text}
                  </div>
                </div>
              );
            })}

            {/* AI typing bubble — shows cursor until text fills in */}
            {onboardingAITyping && (
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '16px' }}>
                <div style={{ maxWidth: '80%', minWidth: '56px', padding: '12px 16px', borderRadius: '4px 16px 16px 16px', background: '#F0F0F0', color: '#1a1a1a', fontSize: '15px', lineHeight: '1.55', wordBreak: 'break-word' }}>
                  {onboardingAITypingText || <span style={{ opacity: 0.4 }}>•••</span>}
                  {onboardingAITypingText && <span style={{ animation: 'blink 1s step-end infinite' }}>|</span>}
                </div>
              </div>
            )}

            {/* User typing bubble */}
            {onboardingUserTyping && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <div style={{ maxWidth: '80%', minWidth: '56px', padding: '12px 16px', borderRadius: '16px 4px 16px 16px', background: '#4A90A4', color: 'white', fontSize: '15px', lineHeight: '1.55', wordBreak: 'break-word' }}>
                  {onboardingUserTypingText || <span style={{ opacity: 0.5 }}>•••</span>}
                  {onboardingUserTypingText && <span style={{ opacity: 0.7 }}>|</span>}
                </div>
              </div>
            )}

            {/* Spacer so the last bubble is never obscured by the CTA */}
            <div style={{ height: onboardingChatStage === 12 ? '96px' : '20px' }} />
          </div>

          {/* CTA — in flex flow so the chat area correctly shrinks above it */}
          {onboardingChatStage === 12 && (
            <div className="fade-up-in" style={{ flexShrink: 0, padding: '16px 24px 36px', background: 'white', borderTop: '1px solid #F0EEEE', boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}>
              <button onClick={function() { handleScreenChange('onboarding-building'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px' }}>
                {'Create ' + n + '\u2019s journey forward'}
              </button>
            </div>
          )}
        </div>
      );
    }

    // ── Building Screen ──────────────────────────────────────────────────────────
    if (currentScreen === 'onboarding-building') {
      var bName = obRecipientFirstName.trim() || onboardingPersonName || 'your loved one';
      var buildingMessages = [
        'Reading your situation\u2026',
        'Mapping local resources near ' + (onboardingZip || 'your area') + '\u2026',
        'Structuring ' + bName + '\u2019s milestones\u2026',
        'Tailoring for your caregiving needs\u2026',
        'Finalizing your journey\u2026'
      ];
      var buildingProgress = [8, 28, 52, 74, 96];
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', background: '#FAFCFD', padding: '0 32px' }}>
          {/* Pulse rings + logo */}
          <div style={{ position: 'relative', width: '96px', height: '96px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '48px' }}>
            {/* Ring 1 */}
            <div style={{ position: 'absolute', width: '96px', height: '96px', borderRadius: '50%', background: 'rgba(74,144,164,0.18)', animation: 'obPulseRing 2s ease-out infinite' }} />
            {/* Ring 2 — staggered */}
            <div style={{ position: 'absolute', width: '96px', height: '96px', borderRadius: '50%', background: 'rgba(74,144,164,0.12)', animation: 'obPulseRing 2s ease-out 0.65s infinite' }} />
            {/* Logo */}
            <div style={{ width: '72px', height: '72px', borderRadius: '22px', background: 'linear-gradient(145deg, #4A90A4 0%, #357A8A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 28px rgba(74,144,164,0.35)', animation: 'obLogoBreath 2.4s ease-in-out infinite', zIndex: 1 }}>
              <span style={{ fontSize: '30px', fontWeight: '700', color: 'white', letterSpacing: '-1px' }}>S</span>
            </div>
          </div>

          {/* Status message — re-keyed on step so animation replays */}
          <div style={{ height: '52px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
            <p key={onboardingBuildingStep} style={{ fontSize: '17px', fontWeight: '500', color: '#1A1A1A', textAlign: 'center', margin: 0, animation: 'obStatusIn 0.4s cubic-bezier(0.4,0,0.2,1) both' }}>
              {buildingMessages[onboardingBuildingStep]}
            </p>
          </div>
          <p style={{ fontSize: '14px', color: '#A0B4BC', textAlign: 'center', margin: '0 0 52px', lineHeight: '1.5' }}>
            {'Building ' + bName + '\u2019s personalized caregiving journey'}
          </p>

          {/* Progress bar */}
          <div style={{ width: '100%', maxWidth: '280px', height: '3px', background: '#E8EDEF', borderRadius: '3px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: buildingProgress[onboardingBuildingStep] + '%', background: 'linear-gradient(90deg, #4A90A4, #357A8A)', borderRadius: '3px', transition: 'width 700ms cubic-bezier(0.4,0,0.2,1)' }} />
          </div>
        </div>
      );
    }

    // ── Roadmap Preview ──────────────────────────────────────────────────────────
    if (currentScreen === 'onboarding-roadmap') {
      var rName = onboardingPersonName || 'Eleanor';
      var rSit = onboardingSituation || 'diagnosis';
      var roadmap = getOnboardingRoadmap(rName, rSit);
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#F4F6F8' }}>
          {/* Hero header */}
          <div style={{ background: 'linear-gradient(160deg, #4A90A4 0%, #357A8A 100%)', padding: '28px 24px 32px', flexShrink: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: '600', color: 'rgba(255,255,255,0.75)', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: '8px' }}>Your personalized roadmap</div>
            <h1 style={{ fontSize: '26px', fontWeight: '700', color: 'white', marginBottom: '6px', lineHeight: '1.25', letterSpacing: '-0.5px' }}>{rName + '\'s journey forward'}</h1>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.82)', lineHeight: '1.5', marginBottom: '20px' }}>{roadmap.milestones.length + ' milestones · built around your situation'}</p>
            {/* Stats row */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
              {[
                { label: 'Milestones', value: roadmap.milestones.length },
                { label: 'Tasks', value: roadmap.milestones.reduce(function(acc, m) { return acc + m.tasks.length; }, 0) },
                { label: 'Weeks', value: '8–12' }
              ].map(function(stat, i) {
                return (
                  <div key={i} style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '10px', padding: '10px 12px', textAlign: 'center' }}>
                    <div style={{ fontSize: '20px', fontWeight: '700', color: 'white' }}>{stat.value}</div>
                    <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.75)', marginTop: '2px' }}>{stat.label}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Scrollable milestone list */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 24px' }}>

            {/* Priority callout */}
            <div style={{ background: 'white', borderRadius: '14px', padding: '16px 18px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', borderLeft: '4px solid #4A90A4' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#4A90A4', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: '10px' }}>Start here — next 48 hours</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {roadmap.priorityTasks.map(function(task, i) {
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                      <div style={{ width: '20px', height: '20px', borderRadius: '50%', border: '2px solid #4A90A4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                        <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#4A90A4' }} />
                      </div>
                      <span style={{ fontSize: '14px', color: '#1a1a1a', lineHeight: '1.45', fontWeight: '500' }}>{task}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Milestone list */}
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#999', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: '10px', paddingLeft: '4px' }}>All milestones</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {roadmap.milestones.map(function(m, idx) {
                var expanded = !!onboardingRoadmapExpanded[idx];
                return (
                  <div key={idx} style={{ background: 'white', borderRadius: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
                    {/* Row header — tap to expand */}
                    <div
                      onClick={function() { setOnboardingRoadmapExpanded(function(prev) { var next = Object.assign({}, prev); next[idx] = !prev[idx]; return next; }); }}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', cursor: 'pointer' }}
                    >
                      {/* Step number badge */}
                      <div style={{ width: '32px', height: '32px', borderRadius: '10px', background: m.isPriority ? 'linear-gradient(135deg, #4A90A4, #357A8A)' : '#F0F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <span style={{ fontSize: '13px', fontWeight: '700', color: m.isPriority ? 'white' : '#7A9BAA' }}>{idx + 1}</span>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', lineHeight: '1.3' }}>{m.title}</div>
                        <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>{m.tasks.length + ' task' + (m.tasks.length !== 1 ? 's' : '')}</div>
                      </div>
                      <div style={{ fontSize: '16px', color: '#C0C8CC', transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 200ms ease', flexShrink: 0 }}>⌄</div>
                    </div>

                    {/* Expanded detail */}
                    {expanded && (
                      <div style={{ borderTop: '1px solid #F0F0F0', padding: '14px 16px 16px' }}>
                        <p style={{ fontSize: '13px', color: '#666', lineHeight: '1.55', marginBottom: '12px' }}>{m.why}</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                          {m.tasks.map(function(task, ti) {
                            return (
                              <div key={ti} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '9px 12px', background: '#F7F9FA', borderRadius: '9px' }}>
                                <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: '1.5px solid #C8D8DE', flexShrink: 0, marginTop: '1px' }} />
                                <span style={{ fontSize: '13px', color: '#444', lineHeight: '1.45' }}>{task}</span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Save CTA — in flex flow, never overlaps content */}
          <div style={{ flexShrink: 0, padding: '14px 20px 36px', background: 'white', borderTop: '1px solid #EBEBEB', boxShadow: '0 -4px 20px rgba(0,0,0,0.06)' }}>
            <button onClick={function() { handleScreenChange('onboarding-save'); }} style={{ width: '100%', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', border: 'none', color: 'white', padding: '17px', borderRadius: '14px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 14px rgba(74,144,164,0.3)' }}>
              {'Save ' + rName + '\u2019s roadmap \u2192'}
            </button>
          </div>
        </div>
      );
    }

    // ── Save / Sign-up Gate ──────────────────────────────────────────────────────
    if (currentScreen === 'onboarding-save') {
      var sName = onboardingPersonName || 'Helen';
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#FDFCFC' }}>
          <div style={{ flex: 1, overflowY: 'auto', padding: '32px 24px 120px' }}>
            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <h1 style={{ fontSize: '26px', fontWeight: '700', color: '#1A1A1A', marginBottom: '10px', letterSpacing: '-0.5px', lineHeight: '1.3' }}>{"Let's save " + sName + "'s roadmap"}</h1>
              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', maxWidth: '300px', margin: '0 auto' }}>{"Take control of " + sName + "'s transition with a plan you can actually follow."}</p>
            </div>

            {/* Value statements */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '36px' }}>
              {[
                'Stop second-guessing every decision about ' + sName + '\'s care',
                'Get your family aligned instead of fighting about next steps',
                'Know exactly what to do next instead of feeling paralyzed'
              ].map(function(stmt, i) {
                return (
                  <div key={i} style={{ background: 'white', padding: '18px 20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'rgba(74,144,164,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>
                      <CheckIcon size={11} />
                    </div>
                    <span style={{ fontSize: '15px', fontWeight: '600', color: '#1A1A1A', lineHeight: '1.45' }}>{stmt}</span>
                  </div>
                );
              })}
            </div>

            {/* Google SSO */}
            <button onClick={function() { handleScreenChange('pulse-check'); }} style={{ width: '100%', background: '#4285F4', color: 'white', border: 'none', borderRadius: '14px', padding: '17px 24px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', boxShadow: '0 4px 12px rgba(66,133,244,0.28)', letterSpacing: '-0.2px' }}>
              <span style={{ fontSize: '18px', fontWeight: '700', fontFamily: 'serif' }}>G</span>
              Continue with Google
            </button>

            {/* Divider */}
            <div style={{ position: 'relative', textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ height: '1px', background: '#E8E8E8' }} />
              <span style={{ position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)', background: '#FDFCFC', padding: '0 14px', fontSize: '13px', color: '#999', fontWeight: '500' }}>or</span>
            </div>

            {/* Email */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <input
                type="text"
                value={onboardingSaveEmail}
                onChange={function(e) { setOnboardingSaveEmail(e.target.value); }}
                placeholder="Enter your email or phone number"
                style={{ width: '100%', padding: '16px 18px', fontSize: '16px', border: '2px solid #F0EEEE', borderRadius: '14px', background: 'white', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s ease' }}
                onFocus={function(e) { e.target.style.borderColor = '#8B5A73'; }}
                onBlur={function(e) { e.target.style.borderColor = '#F0EEEE'; }}
              />
              <button onClick={function() { handleScreenChange('pulse-check'); }} style={{ width: '100%', background: '#8B5A73', color: 'white', border: 'none', borderRadius: '14px', padding: '17px 24px', fontSize: '17px', fontWeight: '600', cursor: 'pointer', minHeight: '56px', letterSpacing: '-0.2px', boxShadow: '0 4px 12px rgba(139,90,115,0.25)' }}>
                Send me the link
              </button>
              <p style={{ fontSize: '13px', color: '#B0BEC5', textAlign: 'center', margin: '4px 0 0' }}>{"We'll send a secure link to access " + sName + "'s roadmap"}</p>
            </div>
          </div>
        </div>
      );
    }

    // ────────────────────────────────────────────────────────────────────────────

    if (currentScreen === 'home') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          {/* Demo Mode Indicator */}
          {demoMode && (
            <div style={{ background: 'linear-gradient(135deg, #FF6B6B, #FF8E8E)', color: 'white', padding: '12px 20px', margin: '8px 16px 0 16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}><VideoIcon size={20} /></div>
                  <div style={{ fontSize: '16px', fontWeight: '600' }}>Demo Mode Active</div>
                </div>
                <button onClick={function() { exitDemoMode(); }} style={{ background: 'rgba(255, 255, 255, 0.2)', border: 'none', color: 'white', padding: '10px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', minHeight: '44px' }}>
                  Exit Demo
                </button>
              </div>
            </div>
          )}

          {/* Demo Scenario Panel */}
          {demoMode && (
            <div style={{ background: 'white', margin: '16px', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '16px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}><MessageIcon size={18} /> AI Demo Scenarios</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <button onClick={function() { triggerScenario('overdue'); }} style={{ padding: '12px', background: '#FFF5F5', border: '2px solid #FFE0E0', borderRadius: '12px', color: '#D63031', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                  Overdue Task
                </button>
                <button onClick={function() { triggerScenario('profile'); }} style={{ padding: '12px', background: '#F0F8FF', border: '2px solid #E0F0FF', borderRadius: '12px', color: '#4A90A4', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                  Profile Update
                </button>
                <button onClick={function() { triggerScenario('progress'); }} style={{ padding: '12px', background: '#F0FFF4', border: '2px solid #E0FFE0', borderRadius: '12px', color: '#00B894', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                  Progress Celebration
                </button>
                <button onClick={function() { triggerScenario('health'); }} style={{ padding: '12px', background: '#FFF8F0', border: '2px solid #FFE8D0', borderRadius: '12px', color: '#E17055', fontSize: '14px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                  Health Concern
                </button>
              </div>
            </div>
          )}

          {/* Welcome Header */}
          {!greetingDismissed && (
            <div style={{
              position: 'relative',
              background: 'linear-gradient(135deg, #4A90A4, #357A8A)',
              color: 'white',
              padding: '20px',
              margin: '8px 16px 0 16px',
              borderRadius: '20px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'opacity 0.35s ease, transform 0.35s ease',
              opacity: greetingFading ? 0 : 1,
              transform: greetingFading ? 'translateY(-6px) scale(0.97)' : 'translateY(0) scale(1)',
            }}>
              <button
                onClick={dismissGreeting}
                style={{
                  position: 'absolute',
                  top: '6px',
                  right: '6px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: 'white',
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  padding: 0,
                  lineHeight: 1,
                }}
              >
                <CloseIcon size={14} />
              </button>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', paddingRight: '32px' }}>
                <div>
                  <div style={{ fontSize: '18px', fontWeight: '600' }}>Good morning, Tess</div>
                  <div style={{ fontSize: '14px', opacity: 0.8 }}>
                    {demoMode ? 'AI Demo Mode Active' : 'How can I help you today?'}
                  </div>
                </div>
                <div style={{ width: '48px', height: '48px', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px' }}>👋</div>
              </div>
              {!demoMode && (
                <div style={{ background: 'rgba(255, 255, 255, 0.15)', borderRadius: '12px', padding: '12px', textAlign: 'center' }}>
                  <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '8px' }}>Need help? Use the Ask Solvyn button below</div>
                  <div style={{ fontSize: '12px', opacity: 0.7 }}>Tap the Ask Solvyn button below for AI assistance</div>
                </div>
              )}
            </div>
          )}
          
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px', paddingBottom: '100px' }}>
            {/* Pulse acknowledgment — no card, open text */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '28px', paddingLeft: '2px' }}>
              <div style={{ width: '3px', borderRadius: '2px', alignSelf: 'stretch', flexShrink: 0, background: pulseState === 'great' ? '#4A90A4' : pulseState === 'steady' ? '#4A7C59' : pulseState === 'strained' ? '#B8860B' : '#8B5A73' }}></div>
              <div>
                <div style={{ fontSize: '15px', fontWeight: '500', color: '#1a1a1a', lineHeight: '1.5', marginBottom: '3px' }}>
                  {pulseState === 'great' && "You're in a good place today — a great time to move something forward."}
                  {pulseState === 'steady' && "You're carrying a lot, and handling it well. One step at a time."}
                  {pulseState === 'strained' && "Today feels heavier — that's okay. We've surfaced only what matters most."}
                  {pulseState === 'overwhelmed' && "This is a lot to hold. You don't have to do everything today."}
                </div>
                <div onClick={function() { handleScreenChange('pulse-check'); }} style={{ fontSize: '12px', color: '#999', cursor: 'pointer', display: 'inline-block' }}>
                  {pulseState === 'great' ? 'Feeling great' : pulseState === 'steady' ? 'Feeling steady' : pulseState === 'strained' ? 'Feeling strained' : 'Feeling overwhelmed'} · Update
                </div>
              </div>
            </div>

            {/* AI Suggested Tasks */}
            {aiTasks.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <SparklesIcon size={18} /> AI Suggested Tasks
                </div>
                {aiTasks.map((task) => (
                  <div key={task.id} style={{ 
                    background: highlightedTask === task.id ? 'linear-gradient(135deg, #FFF5F5, #FFE8E8)' : '#F8F6F6', 
                    borderRadius: '12px', 
                    padding: '16px', 
                    marginBottom: '12px', 
                    border: highlightedTask === task.id ? '2px solid #FF6B6B' : '2px solid #E0E0E0',
                    boxShadow: highlightedTask === task.id ? '0 4px 12px rgba(255, 107, 107, 0.2)' : '0 4px 12px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A' }}>{task.title}</div>
                      <div style={{ background: '#4A90A4', color: 'white', padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>AI Suggested</div>
                    </div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>{task.description}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ fontSize: '12px', color: '#8B5A73' }}>Due: {task.dueDate}</div>
                      <div style={{ fontSize: '12px', color: '#4A90A4', fontStyle: 'italic' }}>{task.aiReason}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{ fontSize: '22px', fontWeight: '600', color: '#1a1a1a' }}>Priority Actions</div>
                <div onClick={function() { setCurrentScreen('journeys'); }} style={{ fontSize: '14px', color: '#8B5A73', fontWeight: '500', cursor: 'pointer' }}>More in Journeys →</div>
              </div>
              
              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', marginBottom: '16px', borderLeft: '4px solid #4A90A4' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Assisted Living for Eleanor</div>
                <div style={{ fontSize: '16px', color: '#5A5858', marginBottom: '16px' }}>Help Eleanor transition to assisted living in Ludlow, MA area</div>
                <div style={{ background: '#E8E6E6', borderRadius: '8px', height: '8px', marginBottom: '16px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', background: '#4A90A4', borderRadius: '8px', width: '35%' }}></div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <button onClick={function() { setCurrentScreen('task-detail'); }} style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 16px', fontSize: '16px', fontWeight: '500', cursor: 'pointer' }}>Schedule Facility Tours</button>
                  <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#F0F8F1', padding: '4px 8px', borderRadius: '12px' }}>Due this week</div>
                </div>
              </div>


              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', marginBottom: '16px', borderLeft: '4px solid #4A90A4' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Your Career Transition to HealthTech</div>
                <div style={{ fontSize: '16px', color: '#5A5858', marginBottom: '16px' }}>Transition from FinTech to HealthTech sales role</div>
                <div style={{ background: '#E8E6E6', borderRadius: '8px', height: '8px', marginBottom: '16px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', background: '#4A90A4', borderRadius: '8px', width: '15%' }}></div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 16px', fontSize: '16px', fontWeight: '500', cursor: 'pointer' }}>Update LinkedIn Profile</button>
                  <div style={{ fontSize: '12px', color: '#B8860B', fontWeight: '500', background: '#FEF9E7', padding: '4px 8px', borderRadius: '12px' }}>Due today</div>
                </div>
              </div>

              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', marginBottom: '16px', borderLeft: '4px solid #8B5A73' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Call Eleanor about groceries</div>
                    <div style={{ fontSize: '14px', color: '#5A5858', marginBottom: '12px' }}>Review grocery needs and coordinate delivery with Eleanor</div>
                  </div>
                  <div style={{ fontSize: '18px' }}>🛒</div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}><PhoneIcon size={14} /> Call Eleanor</button>
                  <div style={{ fontSize: '12px', color: '#B8860B', fontWeight: '500', background: '#FEF9E7', padding: '4px 8px', borderRadius: '12px' }}>Due today</div>
                </div>
              </div>

              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', borderLeft: '4px solid #8B5A73' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Ask Tony to install Eleanor's AC units</div>
                    <div style={{ fontSize: '14px', color: '#5A5858', marginBottom: '12px' }}>Weather getting warmer - coordinate AC installation for Eleanor's home</div>
                  </div>
                  <div style={{ fontSize: '18px' }}>☀️</div>
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}><PhoneIcon size={14} /> Call Tony</button>
                  <div style={{ fontSize: '12px', color: '#8B5A73', fontWeight: '500', background: '#F5F1F4', padding: '4px 8px', borderRadius: '12px' }}>Due this week</div>
                </div>
              </div>
            </div>
          </div>

          {/* Home Prompt Modal */}
          {showHomePrompt && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              padding: '20px'
            }}>
              <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '24px',
                maxWidth: '90%',
                width: '100%',
                maxHeight: '70%',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '40px', height: '40px', background: 'linear-gradient(135deg, #4A90A4, #357A8A)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}><SparklesIcon size={20} /></div>
                    <div>
                      <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>Ask Solvyn</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Your Navigation Guide</div>
                    </div>
                  </div>
                  <button onClick={closeHomePrompt} style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '22px',
                    color: '#999',
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}><CloseIcon size={14} /></button>
                </div>

                {/* Messages */}
                <div style={{
                  flex: 1,
                  overflowY: 'auto',
                  marginBottom: '16px',
                  padding: '12px',
                  background: '#F8F9FA',
                  borderRadius: '12px',
                  minHeight: '120px'
                }} data-home-chat-container>
                  {homePromptMessages.map((message, index) => (
                    <div key={index} style={{
                      display: 'flex',
                      justifyContent: message.type === 'user' ? 'flex-end' : 'flex-start',
                      marginBottom: '12px'
                    }}>
                      <div style={{
                        background: message.type === 'user' ? '#4A90A4' : 'white',
                        color: message.type === 'user' ? 'white' : '#333',
                        padding: '12px 16px',
                        borderRadius: '16px',
                        maxWidth: '85%',
                        fontSize: '14px',
                        lineHeight: '1.4',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        {message.text}
                      </div>
                    </div>
                  ))}
                  {homePromptWorking && (
                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '12px' }}>
                      <div style={{
                        background: 'white',
                        padding: '12px 16px',
                        borderRadius: '16px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                          <div style={{ width: '6px', height: '6px', background: '#4A90A4', borderRadius: '50%', animation: 'pulse 1.4s ease-in-out infinite' }}></div>
                          <div style={{ width: '6px', height: '6px', background: '#4A90A4', borderRadius: '50%', animation: 'pulse 1.4s ease-in-out infinite', animationDelay: '0.2s' }}></div>
                          <div style={{ width: '6px', height: '6px', background: '#4A90A4', borderRadius: '50%', animation: 'pulse 1.4s ease-in-out infinite', animationDelay: '0.4s' }}></div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Input Section */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <textarea
                      value={homePromptInput}
                      onChange={(e) => setHomePromptInput(e.target.value)}
                      placeholder="Type your message..."
                      style={{
                        flex: 1,
                        padding: '12px 16px',
                        borderRadius: '20px',
                        border: '1px solid #E0E0E0',
                        fontSize: '14px',
                        outline: 'none',
                        background: '#F8F8F8',
                        resize: 'none',
                        minHeight: '44px',
                        maxHeight: '120px',
                        lineHeight: '1.4',
                        fontFamily: 'inherit',
                        overflow: 'hidden'
                      }}
                      disabled={homePromptWorking}
                      rows={1}
                      onInput={(e) => {
                        e.target.style.height = 'auto';
                        e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                      }}
                    />
                    <button
                      onClick={sendHomePromptMessage}
                      disabled={!homePromptInput.trim() || homePromptWorking}
                      style={{
                        width: '40px',
                        height: '44px',
                        background: homePromptInput.trim() && !homePromptWorking ? '#4A90A4' : '#E0E0E0',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        cursor: homePromptInput.trim() && !homePromptWorking ? 'pointer' : 'not-allowed',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '16px'
                      }}
                    >
                      <SendIcon />
                    </button>
                  </div>
                  
                  {/* Voice Command Button */}
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button style={{
                      background: 'linear-gradient(135deg, #4A90A4, #357A8A)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '12px',
                      padding: '12px 24px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <MicIcon size={16} /> Use Voice Command
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (currentScreen === 'journeys') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ padding: '24px 20px 16px' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' }}>Your Journeys</div>
            <div style={{ fontSize: '16px', color: '#6b6b6b', fontWeight: '400' }}>People you're supporting and caring for</div>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px 120px 20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              
              <div onClick={function() { handleScreenChange('caroline-detail'); }} style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#4A90A4', marginBottom: '4px' }}>Caroline</div>
                    <div style={{ fontSize: '14px', color: '#6b6b6b' }}>Daughter</div>
                  </div>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A7C59', marginTop: '4px' }}></div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '16px', fontWeight: '500', color: '#2d2c2c' }}>College Preparation</div>
                    <div onClick={(e) => { e.stopPropagation(); handleScreenChange('journey-map'); }} style={{ fontSize: '11px', color: '#4A90A4', fontWeight: '500', cursor: 'pointer', padding: '12px 8px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '8px', minHeight: '44px', display: 'flex', alignItems: 'center' }}>View Map</div>
                  </div>
                  <div style={{ width: '100%', height: '4px', background: '#E0E0E0', borderRadius: '2px', overflow: 'hidden', marginBottom: '8px' }}>
                    <div style={{ height: '100%', background: '#4A90A4', borderRadius: '2px', width: '35%' }}></div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Phase 2 of 6</div>
                </div>
                <div style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', marginBottom: '16px' }}>SAT prep session this Saturday</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid #E8E6E6' }}>
                  <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b6b6b' }}>
                    <div>1 Journey</div>
                    <div>3 Routines</div>
                    <div>8 Resources</div>
                  </div>
                </div>
              </div>

              <div onClick={function() { handleScreenChange('eleanor-detail'); }} style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#4A90A4', marginBottom: '4px' }}>Eleanor</div>
                    <div style={{ fontSize: '14px', color: '#6b6b6b' }}>Mother</div>
                  </div>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A7C59', marginTop: '4px' }}></div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '16px', fontWeight: '500', color: '#2d2c2c' }}>Assisted Living Transition</div>
                    <div onClick={(e) => { e.stopPropagation(); handleScreenChange('journey-map'); }} style={{ fontSize: '11px', color: '#4A90A4', fontWeight: '500', cursor: 'pointer', padding: '12px 8px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '8px', minHeight: '44px', display: 'flex', alignItems: 'center' }}>View Map</div>
                  </div>
                  <div style={{ width: '100%', height: '4px', background: '#E0E0E0', borderRadius: '2px', overflow: 'hidden', marginBottom: '8px' }}>
                    <div style={{ height: '100%', background: '#4A90A4', borderRadius: '2px', width: '25%' }}></div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Phase 2 of 8</div>
                </div>
                <div style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', marginBottom: '16px' }}>Family conversation this weekend</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid #E8E6E6' }}>
                  <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b6b6b' }}>
                    <div>1 Journey</div>
                    <div>4 Routines</div>
                    <div>12 Resources</div>
                  </div>
                </div>
              </div>

              <div onClick={function() { handleScreenChange('tess-detail'); }} style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#4A90A4', marginBottom: '4px' }}>Me - Tess</div>
                    <div style={{ fontSize: '14px', color: '#6b6b6b' }}>Personal</div>
                  </div>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A7C59', marginTop: '4px' }}></div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '16px', fontWeight: '500', color: '#2d2c2c' }}>Career Transition to HealthTech</div>
                    <div onClick={(e) => { e.stopPropagation(); handleScreenChange('journey-map'); }} style={{ fontSize: '11px', color: '#4A90A4', fontWeight: '500', cursor: 'pointer', padding: '12px 8px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '8px', minHeight: '44px', display: 'flex', alignItems: 'center' }}>View Map</div>
                  </div>
                  <div style={{ width: '100%', height: '4px', background: '#E0E0E0', borderRadius: '2px', overflow: 'hidden', marginBottom: '8px' }}>
                    <div style={{ height: '100%', background: '#4A90A4', borderRadius: '2px', width: '15%' }}></div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Phase 1 of 5</div>
                </div>
                <div style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', marginBottom: '16px' }}>Complete skills assessment</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid #E8E6E6' }}>
                  <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b6b6b' }}>
                    <div>1 Journey</div>
                    <div>5 Routines</div>
                    <div>6 Resources</div>
                  </div>
                </div>
              </div>

              {/* Arnold Card (No journey, only routines) */}
              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#4A90A4', marginBottom: '4px' }}>Arnold</div>
                    <div style={{ fontSize: '14px', color: '#6b6b6b' }}>Father</div>
                  </div>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#999', marginTop: '4px' }}></div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ fontSize: '16px', fontWeight: '500', color: '#999', marginBottom: '8px' }}>No Active Journey</div>
                  <div style={{ fontSize: '14px', color: '#999', fontWeight: '400', marginBottom: '16px' }}>Focus on daily routines and resources</div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid #E8E6E6' }}>
                  <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b6b6b' }}>
                    <div>0 Journeys</div>
                    <div>7 Routines</div>
                    <div>5 Resources</div>
                  </div>
                </div>
              </div>

              {/* Lyla Card (Rescued Puppy Journey) */}
              <div onClick={() => handleScreenChange('lyla-detail')} style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', cursor: 'pointer' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <div style={{ fontSize: '18px', fontWeight: '600', color: '#4A90A4' }}>Lyla</div>
                      <div style={{ fontSize: '14px' }}>🐾</div>
                    </div>
                    <div style={{ fontSize: '14px', color: '#6b6b6b' }}>4 months • Husky • Rescued</div>
                  </div>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A7C59', marginTop: '4px' }}></div>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '16px', fontWeight: '500', color: '#2d2c2c' }}>Welcoming a Rescued Puppy</div>
                    <div onClick={(e) => { e.stopPropagation(); handleScreenChange('journey-map'); }} style={{ fontSize: '11px', color: '#4A90A4', fontWeight: '500', cursor: 'pointer', padding: '12px 8px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '8px', minHeight: '44px', display: 'flex', alignItems: 'center' }}>View Map</div>
                  </div>
                  <div style={{ width: '100%', height: '4px', background: '#E0E0E0', borderRadius: '2px', overflow: 'hidden', marginBottom: '8px' }}>
                    <div style={{ height: '100%', background: '#4A90A4', borderRadius: '2px', width: '40%' }}></div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Phase 2 of 5</div>
                </div>
                <div style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', marginBottom: '16px' }}>Potty training and crate training</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '12px', borderTop: '1px solid #E8E6E6' }}>
                  <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: '#6b6b6b' }}>
                    <div>1 Journey</div>
                    <div>8 Routines</div>
                    <div>10 Resources</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (currentScreen === 'eleanor-profile') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          {/* Header */}
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '8px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('eleanor-detail'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Profile</div>
            <button style={{ background: '#4A90A4', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', minHeight: '44px' }}>
              Edit
            </button>
          </div>

          {/* Main Content */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '0 16px 100px 16px' }}>
            
            {/* Basic Information */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', background: '#4A90A4', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                  👤
                </div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Basic Information</div>
              </div>

              <div style={{ display: 'grid', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Full Name</label>
                  <input type="text" value="Eleanor Maria DaCruz" style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Date of Birth</label>
                    <input type="date" value="1949-03-15" style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease' }} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Age</label>
                    <input type="text" value="75 years old" readOnly style={{ height: '48px', background: '#F0F0F0', border: '2px solid #E0E0E0', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#666', cursor: 'not-allowed' }} />
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Relationship to You</label>
                  <select style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', cursor: 'pointer' }}>
                    <option>Mother</option>
                    <option>Father</option>
                    <option>Spouse/Partner</option>
                    <option>Child</option>
                    <option>Sibling</option>
                    <option>Other family member</option>
                    <option>Friend</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Living Situation</label>
                  <select style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', cursor: 'pointer' }}>
                    <option>Lives alone independently</option>
                    <option>Lives with family</option>
                    <option>Assisted living</option>
                    <option>Nursing home</option>
                    <option>Other</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Address</label>
                  <textarea value="123 Oak Street
Ludlow, MA 01056" style={{ minHeight: '80px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '12px 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', resize: 'vertical' }} />
                </div>
              </div>
            </div>

            {/* Health & Care Information */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', background: '#4A90A4', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                  ❤️
                </div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Health & Care</div>
              </div>

              <div style={{ display: 'grid', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Health Conditions</label>
                  <div style={{ marginBottom: '12px' }}>
                    <span style={{ display: 'inline-block', background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500', margin: '4px 4px 4px 0' }}>High Blood Pressure</span>
                    <span style={{ display: 'inline-block', background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500', margin: '4px 4px 4px 0' }}>Arthritis</span>
                    <span style={{ display: 'inline-block', background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500', margin: '4px 4px 4px 0' }}>Mild Memory Issues</span>
                  </div>
                  <button style={{ width: '100%', height: '48px', background: 'rgba(74,144,164,0.05)', border: '1.5px solid rgba(74,144,164,0.4)', borderRadius: '12px', color: '#4A90A4', fontSize: '16px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <svg style={{ width: '20px', height: '20px', stroke: 'currentColor', strokeWidth: '2', fill: 'none' }} viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="16"></line>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                    Add Condition
                  </button>
                  {highlightedFields.includes('healthConditions') && (
                    <div style={{ background: 'linear-gradient(135deg, #FFF5F5, #FFE8E8)', border: '2px solid #FF6B6B', borderRadius: '8px', padding: '12px', marginTop: '8px' }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#D63031', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}><SparklesIcon size={14} /> AI Suggestion:</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Consider updating Eleanor's health conditions based on her recent medication changes. Her care needs may be evolving.</div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Mobility Level</label>
                  <select style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', cursor: 'pointer' }}>
                    <option>Fully independent</option>
                    <option>Independent with minor limitations</option>
                    <option>Needs assistance occasionally</option>
                    <option>Needs daily assistance</option>
                    <option>Requires full-time care</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Cognitive Status</label>
                  <select style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', cursor: 'pointer' }}>
                    <option>No concerns</option>
                    <option>Mild forgetfulness</option>
                    <option>Some confusion at times</option>
                    <option>Significant memory issues</option>
                    <option>Requires supervision</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Special Care Notes</label>
                  <textarea value="Gets confused in the evening. Prefers Portuguese instructions when stressed. Needs reminders for medications but can take them independently." style={{ minHeight: "80px", background: "#F8F6F6", border: "2px solid #F0EEEE", borderRadius: "12px", padding: "12px 16px", fontSize: "16px", color: "#1a1a1a", transition: "all 0.2s ease", resize: "vertical" }} />                </div>
              </div>
            </div>

            {/* Cultural Context Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', background: '#4A90A4', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                  🌍
                </div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Cultural Context</div>
              </div>

              <div style={{ display: 'grid', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Primary Language</label>
                  <select style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', cursor: 'pointer' }}>
                    <option>Portuguese</option>
                    <option>English</option>
                    <option>Bilingual (Portuguese/English)</option>
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Cultural Background</label>
                  <input type="text" value="Portuguese" style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Religious/Spiritual Practices</label>
                  <input type="text" value="Catholic" style={{ height: '48px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '0 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Communication Preferences</label>
                  <textarea value="Prefers formal address as 'Mrs. DaCruz' initially. Speaks Portuguese when stressed or confused. Family decisions typically discussed with all children present." style={{ minHeight: '80px', background: '#F8F6F6', border: '2px solid #F0EEEE', borderRadius: '12px', padding: '12px 16px', fontSize: '16px', color: '#1a1a1a', transition: 'all 0.2s ease', resize: 'vertical' }} />
                </div>
              </div>
            </div>

            {/* Emergency Contacts */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', background: '#4A90A4', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                  <PhoneIcon size={14} />
                </div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Important Contacts</div>
              </div>

              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Dr. Maria Silva</div>
                  <div style={{ background: '#4A90A4', color: 'white', padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>Primary Care</div>
                </div>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  (413) 555-0123 • Mercy Medical Center<br />
                  Speaks Portuguese and English
                </div>
              </div>

              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Antonio DaCruz</div>
                  <div style={{ background: '#4A90A4', color: 'white', padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>Emergency Contact</div>
                </div>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  (413) 555-0456 • Son • Lives nearby<br />
                  Primary emergency contact
                </div>
              </div>

              <button style={{ width: '100%', height: '48px', background: 'rgba(74,144,164,0.05)', border: '1.5px solid rgba(74,144,164,0.4)', borderRadius: '12px', color: '#4A90A4', fontSize: '16px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s ease', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <svg style={{ width: '20px', height: '20px', stroke: 'currentColor', strokeWidth: '2', fill: 'none' }} viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
                Add Contact
              </button>
            </div>
          </div>


          {renderBottomNavigation()}
        </div>
      );
    }

    if (currentScreen === 'eleanor-routines') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('eleanor-detail'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Routines</div>
            <div style={{ minWidth: '44px' }}/>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 120px 20px' }}>
            {/* Care Sections */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              
              {/* Health & Medication */}
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '32px', height: '32px', background: '#A0523D', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px' }}>
                      💊
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
                      Health & Medication
                    </div>
                  </div>
                  <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                    3 items
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8FA', borderRadius: '12px', borderLeft: '4px solid #4A90A4' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Morning Medications
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Lisinopril (10mg) • Aspirin (81mg)
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Best taken with breakfast • Due in 45 min
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Ready
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F4F8', color: '#4A90A4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <PhoneIcon size={18} />
                      </button>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#FFFBF0', borderRadius: '12px', borderLeft: '4px solid #B8860B' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Blood Pressure Check
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Weekly monitoring
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Last check: 5 days ago • Slightly overdue
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#FFF5F0', color: '#B8860B', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Overdue
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#FFF5F0', color: '#B8860B', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        📝
                      </button>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8F0', borderRadius: '12px', borderLeft: '4px solid #4A7C59' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Evening Medications
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Yesterday's dose
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Taken at 6:15 PM • On time
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F5E8', color: '#4A7C59', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Complete
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F5E8', color: '#4A7C59', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CheckIcon size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Daily Living & Wellness */}
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '32px', height: '32px', background: '#4A7C59', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px' }}>
                      🌱
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
                      Daily Living & Wellness
                    </div>
                  </div>
                  <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                    2 items
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8FA', borderRadius: '12px', borderLeft: '4px solid #4A90A4' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Grocery Delivery Check
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Weekly essentials
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Delivery expected today • Confirm receipt
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Today
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F4F8', color: '#4A90A4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <PhoneIcon size={18} />
                      </button>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8F0', borderRadius: '12px', borderLeft: '4px solid #4A7C59' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Physical Activity
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Morning walk around neighborhood
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Completed 30 minutes • Feeling energetic
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F5E8', color: '#4A7C59', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Complete
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F5E8', color: '#4A7C59', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CheckIcon size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social & Emotional */}
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '32px', height: '32px', background: '#8B5A73', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px' }}>
                      👥
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
                      Social & Emotional
                    </div>
                  </div>
                  <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                    1 item
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#FFFBF0', borderRadius: '12px', borderLeft: '4px solid #B8860B' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Family Connection
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Weekly call with grandson Miguel
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Usually calls Sundays • Eleanor mentioned missing him
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#FFF5F0', color: '#B8860B', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Missing
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#FFF5F0', color: '#B8860B', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <MessageIcon size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Safety & Environment */}
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '32px', height: '32px', background: '#B8860B', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '16px' }}>
                      🛡️
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
                      Safety & Environment
                    </div>
                  </div>
                  <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' }}>
                    2 items
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8FA', borderRadius: '12px', borderLeft: '4px solid #4A90A4' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Home Safety Check
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Monthly walkthrough
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Due this week • Focus on bathroom safety
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F4F8', color: '#4A90A4', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        This Week
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F4F8', color: '#4A90A4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        📝
                      </button>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: '#F0F8F0', borderRadius: '12px', borderLeft: '4px solid #4A7C59' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Emergency Contact Update
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                        Updated neighbor contact info
                      </div>
                      <div style={{ fontSize: '12px', color: '#999' }}>
                        Completed yesterday • Mrs. Garcia confirmed
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ background: '#E8F5E8', color: '#4A7C59', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500' }}>
                        Complete
                      </div>
                      <button style={{ width: '44px', height: '44px', border: 'none', borderRadius: '8px', background: '#E8F5E8', color: '#4A7C59', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CheckIcon size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {renderBottomNavigation()}
        </div>
      );
    }

    if (currentScreen === 'eleanor-resources') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('eleanor-detail'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Resources</div>
            <div style={{ minWidth: '44px' }}/>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 120px 20px' }}>
            {/* Healthcare & Medical Section */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '8px', background: '#4A90A4', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', color: 'white', fontSize: '14px' }}>
                  ⚡
                </div>
                <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>
                  Healthcare & Medical
                </h2>
                <span style={{ marginLeft: 'auto', fontSize: '14px', color: '#666', background: '#F8F6F6', borderRadius: '12px', padding: '4px 8px' }}>
                  3 options
                </span>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Dr. Maria Santos
                    </h3>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>
                      Geriatric Pharmacist • 1.2 miles
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Fluent Portuguese
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    House Calls
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Medicare Accepted
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Book Appointment
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    View Profile
                  </button>
                </div>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      PillPack by Amazon
                    </h3>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>
                      Prescription Delivery Service
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Pre-sorted Packets
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Portuguese Support
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Free Delivery
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Sign Up
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Learn More
                  </button>
                </div>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Keystone Commons Memory Care
                    </h3>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>
                      Memory Support Services • 460 West St, Ludlow, MA
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Memory Care
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    24/7 Support
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Family Services
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Call Now
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Learn More
                  </button>
                </div>
              </div>
            </div>

            {/* Medication Management Section */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '8px', background: '#4A90A4', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', color: 'white', fontSize: '14px' }}>
                  💻
                </div>
                <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>
                  Medication Management
                </h2>
                <span style={{ marginLeft: 'auto', fontSize: '14px', color: '#666', background: '#F8F6F6', borderRadius: '12px', padding: '4px 8px' }}>
                  2 options
                </span>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Weekly Pill Organizer with Alarms
                    </h3>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Amazon Product • $24.99
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500', marginRight: '6px' }}>
                    28 Compartments
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500', marginRight: '6px' }}>
                    4 Daily Alarms
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Large Print
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Order on Amazon
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    View Details
                  </button>
                </div>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Automatic Pill Dispenser
                    </h3>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Amazon Product • $89.99
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500', marginRight: '6px' }}>
                    Automatic Dispensing
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500', marginRight: '6px' }}>
                    Caregiver App
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Locking Design
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Order on Amazon
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Watch Demo
                  </button>
                </div>
              </div>
            </div>

            {/* Daily Support Services Section */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ width: '24px', height: '24px', borderRadius: '8px', background: '#4A90A4', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', color: 'white', fontSize: '14px' }}>
                  👥
                </div>
                <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>
                  Daily Support Services
                </h2>
                <span style={{ marginLeft: 'auto', fontSize: '14px', color: '#666', background: '#F8F6F6', borderRadius: '12px', padding: '4px 8px' }}>
                  2 options
                </span>
              </div>
              
              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Ana's Home Care Services
                    </h3>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>
                      Portuguese-speaking aide • 0.8 miles
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Native Portuguese
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Light Housekeeping
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Meal Preparation
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Schedule Visit
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    View Services
                  </button>
                </div>
              </div>

              <div style={{ background: '#FDFCFC', border: '1px solid #F0EEEE', borderRadius: '12px', padding: '20px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>
                      Senior Van Transportation
                    </h3>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>
                      Medical appointment transport • Ludlow area
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', margin: '8px 0' }}>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Door-to-Door
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Wheelchair Accessible
                  </span>
                  <span style={{ background: '#E8F4F6', color: '#4A90A4', borderRadius: '12px', padding: '4px 8px', fontSize: '12px', fontWeight: '500' }}>
                    Insurance Accepted
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button style={{ background: '#4A90A4', color: 'white', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    Book Ride
                  </button>
                  <button style={{ background: 'transparent', color: '#4A90A4', border: '2px solid #4A90A4', borderRadius: '8px', padding: '8px 16px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', flex: 1, transition: 'all 0.2s ease' }}>
                    View Schedule
                  </button>
                </div>
              </div>
            </div>
          </div>

          {renderBottomNavigation()}
        </div>
      );
    }

    if (currentScreen === 'eleanor-detail') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('journeys'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Eleanor</div>
            <div style={{ minWidth: '44px' }}/>
          </div>
          <div style={{ padding: '20px', background: '#F8F6F6', borderBottom: '1px solid #E8E6E6' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#D1CFCF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: '600', color: '#6B6B6B' }}>E</div>
                <div>
                  <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1A1A1A', marginBottom: '4px' }}>Eleanor</h1>
                  <div style={{ fontSize: '16px', color: '#6B6B6B', marginBottom: '8px' }}>Mother • 75 years old</div>
                  <div style={{ fontSize: '14px', color: '#8B5A73' }}>Ludlow, MA • Portuguese speaker</div>
                </div>
              </div>
              <div onClick={function() { setCurrentScreen('eleanor-profile'); }} style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', cursor: 'pointer', padding: '12px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '8px', transition: 'all 0.2s ease', minHeight: '44px', display: 'flex', alignItems: 'center' }}>
                View Profile
              </div>
            </div>
          </div>
          
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 120px 20px' }}>
            <div style={{ marginBottom: '32px' }}>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '16px' }}>Active Journey</div>
              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '12px' }}>Assisted Living Transition</div>
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ width: '100%', height: '4px', background: '#E0E0E0', borderRadius: '2px', overflow: 'hidden', marginBottom: '6px' }}>
                    <div style={{ height: '100%', background: '#4A90A4', borderRadius: '2px', width: '25%' }}></div>
                  </div>
                  <div style={{ fontSize: '12px', color: '#6B6B6B' }}>Phase 2 of 8 • 25% complete</div>
                </div>
                <div style={{ fontSize: '14px', color: '#4A90A4', fontWeight: '500', marginBottom: '12px' }}>Family conversation this weekend</div>
                <div onClick={function() { setCurrentScreen('journey-map'); }} style={{ fontSize: '12px', color: '#8B5A73', fontWeight: '500', textAlign: 'center', padding: '8px', background: 'rgba(139, 90, 115, 0.1)', borderRadius: '8px', cursor: 'pointer' }}>Tap to view full journey map</div>
              </div>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>Past Journeys</div>
                    <div style={{ fontSize: '14px', color: '#6B6B6B' }}>2 completed journeys</div>
                  </div>
                  <div style={{ fontSize: '18px', color: '#8B5A73' }}>▶</div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>Routines</div>
                <div onClick={function() { setCurrentScreen('eleanor-routines'); }} style={{ fontSize: '14px', color: '#8B5A73', fontWeight: '500', cursor: 'pointer' }}>See all →</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{ fontSize: '18px' }}>💊</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '2px' }}>Morning Medications</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B' }}>Daily at 8:00 AM</div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#F0F8F1', padding: '4px 8px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}><CheckIcon size={10} /> Today</div>
                  </div>
                </div>

                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{ fontSize: '18px' }}>🍽️</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '2px' }}>Meal Check-in</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B' }}>Daily at 12:00 PM & 6:00 PM</div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#B8860B', fontWeight: '500', background: '#FEF9E7', padding: '4px 8px', borderRadius: '12px' }}>Due 6PM</div>
                  </div>
                </div>

                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', color: '#4A90A4' }}><PhoneIcon size={18} /></div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '2px' }}>Evening Call</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B' }}>Daily at 7:00 PM</div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#8B5A73', fontWeight: '500', background: '#F5F1F4', padding: '4px 8px', borderRadius: '12px' }}>Pending</div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '32px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A' }}>Resources</div>
                <div onClick={function() { setCurrentScreen('eleanor-resources'); }} style={{ fontSize: '14px', color: '#8B5A73', fontWeight: '500', cursor: 'pointer' }}>See all →</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <div style={{ fontSize: '18px' }}>🏥</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>Ludlow Senior Care Center</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B', marginBottom: '8px' }}>Primary care facility • 2.1 miles away</div>
                      <div style={{ fontSize: '12px', color: '#4A90A4', fontWeight: '500' }}>Dr. Maria Santos • (413) 555-0123</div>
                    </div>
                  </div>
                </div>

                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <div style={{ fontSize: '18px' }}>🛒</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>Big Y Grocery Delivery</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B', marginBottom: '8px' }}>Weekly grocery delivery service</div>
                      <div style={{ fontSize: '12px', color: '#4A90A4', fontWeight: '500' }}>Next delivery: Thursday 2PM</div>
                    </div>
                  </div>
                </div>

                <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', color: '#4A90A4' }}><GlobeIcon size={18} /></div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>Portuguese Translation Service</div>
                      <div style={{ fontSize: '14px', color: '#6B6B6B', marginBottom: '8px' }}>24/7 medical interpretation support</div>
                      <div style={{ fontSize: '12px', color: '#4A90A4', fontWeight: '500' }}>Call: (800) 555-TRANSLATE</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (currentScreen === 'journey-map') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('eleanor-detail'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Journey Map</div>
            <div style={{ minWidth: '44px' }}/>
          </div>
          
          <div style={{ flex: 1, padding: '20px', paddingBottom: '120px', overflowY: 'auto' }}>
            <div style={{ background: '#8B5A73', color: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px' }}>
              <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '8px' }}>Your Journey</h2>
              <p style={{ fontSize: '16px', opacity: 0.9, marginBottom: '16px' }}>Complete roadmap to Eleanor assisted living transition</p>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>7</div>
                  <div style={{ fontSize: '12px', opacity: 0.8 }}>Completed</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>1</div>
                  <div style={{ fontSize: '12px', opacity: 0.8 }}>In Progress</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>3</div>
                  <div style={{ fontSize: '12px', opacity: 0.8 }}>Upcoming</div>
                </div>
              </div>
            </div>

            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', left: '28px', top: '0', bottom: '0', width: '2px', background: '#F0EEEE', zIndex: 1 }}></div>
              
              {/* AI Suggested Milestones */}
              {aiMilestones.map((milestone) => (
                <div key={milestone.id} style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                  <div style={{ 
                    background: 'linear-gradient(135deg, #F0F8FF, #E0F0FF)', 
                    padding: '16px', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 12px rgba(74, 144, 164, 0.2)',
                    border: '2px solid #4A90A4'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A90A4', color: 'white' }}><SparklesIcon size={26} /></div>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>{milestone.title}</h3>
                          <div style={{ background: '#4A90A4', color: 'white', padding: '4px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>AI Suggested</div>
                        </div>
                        <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>{milestone.aiReason}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          {milestone.tasks.map((task, taskIndex) => (
                            <div key={taskIndex} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#4A90A4' }}></div>
                              <div style={{ fontSize: '12px', color: '#666' }}>{task}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              
              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Evaluate the needs of our loved one</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Identify stakeholders and collaborators</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Have a conversation with our family and friends</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Have a conversation with your loved one</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Talk to employer about caregiving duties</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Evaluate financial situation of our loved one</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: '#4A7C59', color: 'white' }}><CheckIcon size={24} /></div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Define budget and evaluate payment options</h3>
                      <div style={{ fontSize: '12px', color: '#4A7C59', fontWeight: '500', background: '#E8F5E8', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Completed</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '24px', zIndex: 2 }}>
                <div style={{ position: 'absolute', left: '20px', top: '16px', width: '16px', height: '16px', background: '#B8860B', border: '4px solid white', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}></div>
                <div onClick={function() { setCurrentScreen('milestone-detail'); }} style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '2px solid #B8860B', cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, background: '#B8860B', color: 'white' }}>🏢</div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Evaluate and select a facility</h3>
                      <div style={{ fontSize: '12px', color: '#B8860B', fontWeight: '500', background: '#FFF5E6', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>In Progress</div>
                    </div>
                  </div>
                  <div style={{ marginLeft: '72px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <div style={{ background: '#E8F5E8', borderRadius: '8px', padding: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#4A7C59', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CheckIcon size={9} /></div>
                        <span style={{ fontSize: '14px', color: '#1a1a1a' }}>Review personal criteria and any special needs</span>
                      </div>
                      <div style={{ background: '#E8F5E8', borderRadius: '8px', padding: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#4A7C59', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CheckIcon size={9} /></div>
                        <span style={{ fontSize: '14px', color: '#1a1a1a' }}>Create list of possible facilities</span>
                      </div>
                      <div style={{ background: '#FFF5E6', borderRadius: '8px', padding: '12px', display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #B8860B' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#B8860B', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px' }}>→</div>
                        <span style={{ fontSize: '14px', color: '#1a1a1a', fontWeight: '500' }}>Visit and tour facilities</span>
                      </div>
                      <div style={{ background: '#F8F6F6', borderRadius: '8px', padding: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#F0EEEE', color: '#999', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px' }}>○</div>
                        <span style={{ fontSize: '14px', color: '#666' }}>Compare, prioritize, and select a facility</span>
                      </div>
                      <div style={{ background: '#F8F6F6', borderRadius: '8px', padding: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: '#F0EEEE', color: '#999', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px' }}>○</div>
                        <span style={{ fontSize: '14px', color: '#666' }}>Discuss logistics with the selected facility</span>
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#8B5A73', textAlign: 'center', marginTop: '12px', padding: '8px', background: 'rgba(139, 90, 115, 0.1)', borderRadius: '8px' }}>
                      Tap to view detailed tasks and resources →
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '16px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, background: '#F0EEEE', color: '#999' }}>🏠</div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Close the chapter of our current living situation</h3>
                      <div style={{ fontSize: '12px', color: '#999', fontWeight: '500', background: '#F8F6F6', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Upcoming</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '16px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, background: '#F0EEEE', color: '#999' }}>🎉</div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Start our new chapter in our new home</h3>
                      <div style={{ fontSize: '12px', color: '#999', fontWeight: '500', background: '#F8F6F6', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Upcoming</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', marginBottom: '16px', zIndex: 2 }}>
                <div style={{ background: 'white', padding: '16px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '56px', height: '56px', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0, background: '#F0EEEE', color: '#999' }}>💕</div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Transitioning to our new relationship</h3>
                      <div style={{ fontSize: '12px', color: '#999', fontWeight: '500', background: '#F8F6F6', padding: '2px 6px', borderRadius: '8px', display: 'inline-block' }}>Upcoming</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (currentScreen === 'milestone-detail') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('journey-map'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Milestone</div>
            <div style={{ minWidth: '44px' }}/>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '120px' }}>
            <div style={{ background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', padding: '24px 20px 32px', color: 'white', position: 'relative', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
                <div style={{ width: '56px', height: '56px', background: 'rgba(255,255,255,0.2)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '28px' }}>
                  🏢
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>
                    Research & Select Facility
                  </div>
                  <div 
                    onClick={function() { setMilestoneExplanationExpanded(!milestoneExplanationExpanded); }} 
                    style={{ 
                      fontSize: '14px', 
                      opacity: 0.8, 
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <span>Why this milestone matters for Eleanor's independence</span>
                    <span style={{ fontSize: '12px', transition: 'transform 0.2s ease', transform: milestoneExplanationExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                      ▼
                    </span>
                  </div>
                  {milestoneExplanationExpanded && (
                    <div style={{ 
                      fontSize: '14px', 
                      opacity: 0.8, 
                      marginTop: '12px',
                      lineHeight: '1.5',
                      padding: '12px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '8px',
                      border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}>
                      This milestone ensures Eleanor feels involved in choosing her new living situation. By researching together and visiting facilities as a team, we help her maintain dignity and control over this major life transition. Taking time to find the right cultural fit and care level prevents future moves and supports her long-term wellbeing.
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '24px' }}>
                <div style={{ position: 'relative' }}>
                  <svg width="72" height="72" style={{ transform: 'rotate(-90deg)' }}>
                    <circle cx="36" cy="36" r="30" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="6" />
                    <circle cx="36" cy="36" r="30" fill="none" stroke="white" strokeWidth="6" strokeLinecap="round" 
                            strokeDasharray="188.5" strokeDashoffset="113.1" />
                  </svg>
                  <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '16px', fontWeight: '700' }}>
                    40%
                  </div>
                </div>
                
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', gap: '24px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '700' }}>2</div>
                      <div style={{ fontSize: '12px', opacity: 0.8 }}>Done</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '700' }}>1</div>
                      <div style={{ fontSize: '12px', opacity: 0.8 }}>Active</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '700' }}>2</div>
                      <div style={{ fontSize: '12px', opacity: 0.8 }}>Next</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '12px', padding: '16px' }}>
                <div style={{ fontSize: '12px', opacity: 0.8, marginBottom: '4px' }}>
                  Next Action
                </div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>
                  Schedule tours with Eleanor for this week
                </div>
              </div>
            </div>

            <div style={{ padding: '24px 20px' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', marginBottom: '16px' }}>
                Your Tasks
              </div>

              {/* Completed Tasks Summary */}
              <div onClick={function() { 
                const container = document.getElementById('completed-tasks-container');
                const expandIcon = document.getElementById('completed-expand-icon');
                if (container && expandIcon) {
                  if (container.style.display === 'none' || !container.style.display) {
                    container.style.display = 'block';
                    expandIcon.style.transform = 'rotate(180deg)';
                  } else {
                    container.style.display = 'none';
                    expandIcon.style.transform = 'rotate(0deg)';
                  }
                }
              }} style={{ background: '#F8FDF9', border: '1px solid #E8F5E8', borderRadius: '12px', padding: '20px', marginBottom: '16px', cursor: 'pointer', transition: 'all 0.2s ease' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '40px', height: '40px', background: '#4A7C59', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                    <CheckIcon size={18} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#4A7C59', marginBottom: '2px' }}>
                      2 tasks completed
                    </div>
                    <div style={{ fontSize: '14px', color: '#666' }}>
                      Tap to view details
                    </div>
                  </div>
                  <div id="completed-expand-icon" style={{ width: '20px', height: '20px', color: '#4A7C59', fontSize: '16px', transition: 'transform 0.2s ease' }}>
                    ▼
                  </div>
                </div>
              </div>

              {/* Collapsed Completed Tasks */}
              <div id="completed-tasks-container" style={{ display: 'none', marginBottom: '16px' }}>
                <div style={{ background: 'white', borderRadius: '12px', padding: '16px 20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #4A7C59', marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#4A7C59', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckIcon size={12} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>
                        Review personal criteria and any special needs
                      </div>
                      <div style={{ fontSize: '12px', color: '#4A7C59' }}>
                        Completed Oct 15
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ background: 'white', borderRadius: '12px', padding: '16px 20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #4A7C59', marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#4A7C59', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CheckIcon size={12} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>
                        Create list of possible facilities
                      </div>
                      <div style={{ fontSize: '12px', color: '#4A7C59' }}>
                        Completed Oct 18
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <div onClick={function() { setCurrentScreen('task-detail'); }} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #B8860B', cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#B8860B', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                      →
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Visit and tour facilities
                      </div>
                      <div style={{ fontSize: '14px', color: '#666', marginBottom: '12px' }}>
                        Schedule tours with Eleanor at your top 3 choices. Bring checklist and take photos.
                      </div>
                      <div style={{ fontSize: '12px', color: '#A0523D', fontWeight: '600' }}>
                        Due Friday
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #F0EEEE' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#F0EEEE', color: '#999', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                      ○
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Compare, prioritize, and select a facility
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        After tours
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '16px' }}>
                <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #F0EEEE' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#F0EEEE', color: '#999', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                      ○
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                        Discuss logistics with selected facility
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Next week
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ background: 'linear-gradient(135deg, #8B5A73 0%, #704660 100%)', color: 'white', padding: '24px 20px', marginBottom: '32px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}><SparklesIcon size={18} /></div>
                <div style={{ fontSize: '18px', fontWeight: '700' }}>Smart Suggestion</div>
              </div>
              <div style={{ fontSize: '14px', marginBottom: '16px' }}>
                Based on Eleanor's Portuguese background, I found 2 facilities in your area with Portuguese-speaking staff and cultural meal options.
              </div>
              <button style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', padding: '12px 20px', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
                View Cultural Facilities
              </button>
            </div>

            <div style={{ background: '#F8F6F6', padding: '24px 20px' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', marginBottom: '16px' }}>
                Helpful Resources
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Video Resources */}
                <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ position: 'relative', width: '100%', height: '140px', background: '#000' }}>
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='335' height='140'%3E%3Crect width='100%25' height='100%25' fill='%23e0e0e0'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='14' fill='%23666' text-anchor='middle' dy='.3em'%3EAssisted Living Tour Tips%3C/text%3E%3C/svg%3E" alt="Video thumbnail" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <div style={{ position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div style={{ width: '48px', height: '48px', background: 'rgba(255,255,255,0.9)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#4A90A4', fontWeight: 'bold', paddingLeft: '3px' }}>
                        ▶
                      </div>
                    </div>
                    <div style={{ position: 'absolute', bottom: '8px', right: '8px', background: 'rgba(0,0,0,0.8)', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '500' }}>
                      8:42
                    </div>
                    <div style={{ position: 'absolute', top: '8px', left: '8px', padding: '4px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', background: '#4A7C59', color: 'white' }}>
                      Expert Tip
                    </div>
                  </div>
                  <div style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                      What to Look for During Facility Tours
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      Essential questions and key observations to make
                    </div>
                  </div>
                </div>

                <div style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ position: 'relative', width: '100%', height: '140px', background: '#000' }}>
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='335' height='140'%3E%3Crect width='100%25' height='100%25' fill='%23d0d0d0'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='14' fill='%23666' text-anchor='middle' dy='.3em'%3EIncluding Your Loved One%3C/text%3E%3C/svg%3E" alt="Video thumbnail" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <div style={{ position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div style={{ width: '48px', height: '48px', background: 'rgba(255,255,255,0.9)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#4A90A4', fontWeight: 'bold', paddingLeft: '3px' }}>
                        ▶
                      </div>
                    </div>
                    <div style={{ position: 'absolute', bottom: '8px', right: '8px', background: 'rgba(0,0,0,0.8)', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '500' }}>
                      12:15
                    </div>
                    <div style={{ position: 'absolute', top: '8px', left: '8px', padding: '4px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', background: '#8B5A73', color: 'white' }}>
                      Family Story
                    </div>
                  </div>
                  <div style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
                      How to Include Your Loved One in Decisions
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      Real family shares their experience navigating choices
                    </div>
                  </div>
                </div>

                {/* Online Resources */}
                <div style={{ background: 'white', borderRadius: '12px', padding: '16px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #4A90A4' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '40px', height: '40px', background: '#4A90A4', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                      <ClipboardIcon size={18} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>
                        Assisted Living Facility Tour Checklist
                      </div>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                        Comprehensive guide from AARP
                      </div>
                      <div style={{ fontSize: '11px', color: '#4A90A4', fontWeight: '500' }}>
                        aarp.org/caregiving
                      </div>
                    </div>
                    <div style={{ fontSize: '16px', color: '#4A90A4' }}>
                      →
                    </div>
                  </div>
                </div>

                <div style={{ background: 'white', borderRadius: '12px', padding: '16px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderLeft: '4px solid #8B5A73' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ width: '40px', height: '40px', background: '#8B5A73', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                      <GlobeIcon size={18} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>
                        Massachusetts Senior Living Directory
                      </div>
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                        Find licensed facilities near Ludlow, MA
                      </div>
                      <div style={{ fontSize: '11px', color: '#8B5A73', fontWeight: '500' }}>
                        mass.gov/senior-services
                      </div>
                    </div>
                    <div style={{ fontSize: '16px', color: '#8B5A73' }}>
                      →
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (currentScreen === 'task-detail') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#F8F6F6' }}>
          {/* Nav bar */}
          <div style={{ height: '56px', background: 'white', borderBottom: '1px solid rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', paddingLeft: '4px', paddingRight: '16px', position: 'sticky', top: 0, zIndex: 10, flexShrink: 0 }}>
            <button onClick={function() { handleScreenChange('milestone-detail'); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px 12px', display: 'flex', alignItems: 'center', color: '#4A90A4', minWidth: '44px', minHeight: '44px', justifyContent: 'center' }}>
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1L1 8l7 7"/></svg>
            </button>
            <div style={{ flex: 1, textAlign: 'center', fontSize: '16px', fontWeight: '600', color: '#1a1a1a' }}>Schedule Tours</div>
            <button onClick={function() {
              const modal = document.getElementById('status-modal');
              if (modal) modal.style.display = 'flex';
            }} style={{ background: 'rgba(74,144,164,0.1)', border: 'none', borderRadius: '12px', padding: '5px 10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', minHeight: '44px' }}>
              <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#4A90A4', flexShrink: 0 }}></span>
              <span style={{ fontSize: '12px', fontWeight: '600', color: '#4A90A4' }}>In Progress</span>
            </button>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '100px' }}>

            {/* Progress strip */}
            <div style={{ background: 'white', padding: '16px 20px', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>1 of 3 tours scheduled</div>
                <button onClick={function() {
                  const modal = document.getElementById('date-modal');
                  if (modal) modal.style.display = 'flex';
                }} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', color: '#B8860B', padding: '4px 0' }}>
                  <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#B8860B', flexShrink: 0 }}></span>
                  <span id="due-date-text" style={{ fontSize: '12px', fontWeight: '600' }}>Due Friday · 3 days left</span>
                </button>
              </div>
              <div style={{ height: '6px', background: '#F0EEEE', borderRadius: '3px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: '33%', background: '#4A90A4', borderRadius: '3px', transition: 'width 0.4s ease' }}></div>
              </div>
            </div>

            {/* AI tip banner */}
            <div style={{ margin: '16px 16px 0', background: 'rgba(139,90,115,0.07)', border: '1px solid rgba(139,90,115,0.15)', borderRadius: '12px', padding: '12px 14px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              <div style={{ color: '#8B5A73', flexShrink: 0, paddingTop: '1px' }}><SparklesIcon size={14} /></div>
              <div style={{ fontSize: '13px', color: '#5a3a4a', lineHeight: '1.5', flex: 1 }}>
                Schedule tours <strong>10 AM – 2 PM</strong> — Eleanor is most alert then. Avoid Mondays (staff meetings).
              </div>
            </div>

            {/* Facility cards */}
            <div style={{ padding: '16px 16px 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Your facilities</div>
                <button onClick={function() {
                  const modal = document.getElementById('add-facility-modal');
                  if (modal) modal.style.display = 'flex';
                }} style={{ background: 'rgba(74,144,164,0.08)', border: '1.5px solid rgba(74,144,164,0.3)', borderRadius: '8px', color: '#4A90A4', fontSize: '12px', fontWeight: '600', padding: '5px 12px', cursor: 'pointer' }}>
                  + Add
                </button>
              </div>

              {/* Casa do Sol — tour scheduled */}
              <div style={{ background: 'white', borderRadius: '16px', padding: '18px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  <div style={{ width: '44px', height: '44px', background: '#4A90A4', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: '700', flexShrink: 0 }}>CS</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#1a1a1a', marginBottom: '3px' }}>Casa do Sol Senior Living</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
                      <span style={{ background: '#B8860B', color: 'white', fontSize: '11px', padding: '2px 7px', borderRadius: '6px', fontWeight: '600' }}>🇵🇹 Portuguese Staff</span>
                      <span style={{ fontSize: '12px', color: '#666' }}>2.1 mi · 4.8★</span>
                      <span style={{ fontSize: '11px', color: '#8B5A73', fontWeight: '600' }}>AI suggested</span>
                    </div>
                    {/* Tour booked */}
                    <div style={{ background: 'rgba(74,124,89,0.08)', border: '1px solid rgba(74,124,89,0.2)', borderRadius: '10px', padding: '10px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ color: '#4A7C59' }}><CalendarIcon size={14} /></div>
                        <div>
                          <div style={{ fontSize: '13px', fontWeight: '700', color: '#4A7C59' }}>Thu, Apr 7 · 2:00 PM</div>
                          <div style={{ fontSize: '11px', color: '#4A7C59', opacity: 0.8 }}>Tour confirmed</div>
                        </div>
                      </div>
                      <button style={{ background: 'none', border: 'none', color: '#4A7C59', fontSize: '12px', fontWeight: '600', cursor: 'pointer', padding: '4px 8px' }}>Reschedule</button>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button style={{ flex: 1, background: '#F8F6F6', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '600', color: '#4A90A4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <PhoneIcon size={13} /> Call
                  </button>
                  <button style={{ flex: 1, background: '#F8F6F6', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '600', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <MessageIcon size={13} /> Notes (1)
                  </button>
                </div>
              </div>

              {/* Sunset Manor — not scheduled */}
              <div style={{ background: 'white', borderRadius: '16px', padding: '18px', marginBottom: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  <div style={{ width: '44px', height: '44px', background: '#8B5A73', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: '700', flexShrink: 0 }}>SM</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#1a1a1a', marginBottom: '3px' }}>Sunset Manor</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
                      <span style={{ fontSize: '12px', color: '#666' }}>3.4 mi · 4.6★ · Cultural meals</span>
                      <span style={{ fontSize: '11px', color: '#4A7C59', fontWeight: '600' }}>You added</span>
                    </div>
                    {/* No tour yet */}
                    <div style={{ background: '#F8F6F6', borderRadius: '10px', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ color: '#999' }}><CalendarIcon size={14} /></div>
                      <div style={{ fontSize: '13px', color: '#999' }}>No tour scheduled yet</div>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button style={{ flex: 2, background: '#4A90A4', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '700', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <PhoneIcon size={13} /> Call to Schedule
                  </button>
                  <button style={{ flex: 1, background: '#F8F6F6', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '600', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <MessageIcon size={13} /> Notes
                  </button>
                </div>
              </div>

              {/* Riverside Commons — not scheduled */}
              <div style={{ background: 'white', borderRadius: '16px', padding: '18px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  <div style={{ width: '44px', height: '44px', background: '#4A7C59', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: '700', flexShrink: 0 }}>RC</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#1a1a1a', marginBottom: '3px' }}>Riverside Commons</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', marginBottom: '10px' }}>
                      <span style={{ background: '#B8860B', color: 'white', fontSize: '11px', padding: '2px 7px', borderRadius: '6px', fontWeight: '600' }}>🇵🇹 Portuguese Community</span>
                      <span style={{ fontSize: '12px', color: '#666' }}>4.2 mi · 4.7★</span>
                      <span style={{ fontSize: '11px', color: '#8B5A73', fontWeight: '600' }}>AI suggested</span>
                    </div>
                    {/* No tour yet */}
                    <div style={{ background: '#F8F6F6', borderRadius: '10px', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ color: '#999' }}><CalendarIcon size={14} /></div>
                      <div style={{ fontSize: '13px', color: '#999' }}>No tour scheduled yet</div>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button style={{ flex: 2, background: '#4A90A4', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '700', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <PhoneIcon size={13} /> Call to Schedule
                  </button>
                  <button style={{ flex: 1, background: '#F8F6F6', border: 'none', borderRadius: '10px', padding: '11px', fontSize: '13px', fontWeight: '600', color: '#666', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <MessageIcon size={13} /> Notes
                  </button>
                </div>
              </div>
            </div>

            {/* Family notes */}
            <div style={{ padding: '0 16px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  Family Notes
                  <span style={{ background: '#A0523D', color: 'white', fontSize: '10px', padding: '1px 6px', borderRadius: '10px', fontWeight: '700' }}>2 new</span>
                </div>
                <button onClick={function() {
                  const modal = document.getElementById('add-note-modal');
                  if (modal) modal.style.display = 'flex';
                }} style={{ background: 'none', border: 'none', color: '#4A90A4', fontSize: '13px', fontWeight: '600', cursor: 'pointer', padding: '4px 0' }}>+ Add note</button>
              </div>
              <div style={{ background: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '16px', borderBottom: '1px solid #F8F6F6' }}>
                  <div style={{ width: '34px', height: '34px', background: '#4A90A4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '13px', fontWeight: '700', flexShrink: 0 }}>Y</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1a1a' }}>You</span>
                      <span style={{ fontSize: '11px', color: '#999' }}>1 hour ago</span>
                      <span style={{ background: 'rgba(160,82,61,0.1)', color: '#A0523D', fontSize: '10px', fontWeight: '700', padding: '1px 6px', borderRadius: '8px' }}>new</span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#1a1a1a', lineHeight: '1.5' }}>
                      Toured Casa do Sol with Eleanor — she loved the courtyard and Portuguese Mass on Sundays. <span style={{ color: '#4A90A4', fontWeight: '600' }}>@Maria</span> can you ask about PT when you call?
                    </div>
                    <a href="#" style={{ color: '#8B5A73', textDecoration: 'none', fontWeight: '600', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '8px' }}>📸 Photos from our visit</a>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '16px', borderBottom: '1px solid #F8F6F6' }}>
                  <div style={{ width: '34px', height: '34px', background: '#4A90A4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '13px', fontWeight: '700', flexShrink: 0 }}>M</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1a1a' }}>Maria</span>
                      <span style={{ fontSize: '11px', color: '#999' }}>3 hours ago</span>
                      <span style={{ background: 'rgba(160,82,61,0.1)', color: '#A0523D', fontSize: '10px', fontWeight: '700', padding: '1px 6px', borderRadius: '8px' }}>new</span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#1a1a1a', lineHeight: '1.5' }}>
                      <span style={{ color: '#4A90A4', fontWeight: '600' }}>@Everyone</span> Riverside has a Portuguese card group every Thursday — Eleanor would love it! Pricing details:
                    </div>
                    <a href="#" style={{ color: '#8B5A73', textDecoration: 'none', fontWeight: '600', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '8px' }}>📄 Riverside pricing</a>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '16px' }}>
                  <div style={{ width: '34px', height: '34px', background: '#B8860B', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '13px', fontWeight: '700', flexShrink: 0 }}>E</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ fontSize: '13px', fontWeight: '700', color: '#1a1a1a' }}>Eleanor</span>
                      <span style={{ fontSize: '11px', color: '#999' }}>5 hours ago</span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#1a1a1a', lineHeight: '1.5' }}>
                      I want a nice dining room where we're not rushed. Can we ask about this? <span style={{ color: '#4A90A4', fontWeight: '600' }}>@You</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Resources — compact list */}
            <div style={{ padding: '0 16px 16px' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px' }}>Resources</div>
              <div style={{ background: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', borderBottom: '1px solid #F8F6F6', cursor: 'pointer' }}>
                  <div style={{ width: '32px', height: '32px', background: 'rgba(74,144,164,0.1)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4A90A4', flexShrink: 0 }}><ClipboardIcon size={14} /></div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>Pre-tour checklist</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>What to bring & look for</div>
                  </div>
                  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 1l5 5-5 5"/></svg>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', borderBottom: '1px solid #F8F6F6', cursor: 'pointer' }}>
                  <div style={{ width: '32px', height: '32px', background: 'rgba(139,90,115,0.1)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8B5A73', flexShrink: 0 }}><QuestionIcon size={14} /></div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>Key questions to ask</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>Customized for Eleanor</div>
                  </div>
                  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 1l5 5-5 5"/></svg>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', cursor: 'pointer' }}>
                  <div style={{ width: '32px', height: '32px', background: 'rgba(74,144,164,0.1)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4A90A4', flexShrink: 0 }}><VideoIcon size={14} /></div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>How to tour assisted living</div>
                    <div style={{ fontSize: '12px', color: '#999' }}>Video · 12 min</div>
                  </div>
                  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 1l5 5-5 5"/></svg>
                </div>
              </div>
            </div>

            {/* Status Change Modal */}
            <div id="status-modal" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.5)', display: 'none', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', maxWidth: '340px', width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }}>Update Task Status</div>
                  <button onClick={function() {
                    const modal = document.getElementById('status-modal');
                    if (modal) modal.style.display = 'none';
                  }} style={{ background: 'none', border: 'none', padding: '0', cursor: 'pointer', borderRadius: '50%', color: '#666', minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CloseIcon size={16} />
                  </button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
                  <div onClick={function() { updateTaskStatus('to-do', '#999', 'To Do'); }} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '2px solid #F0EEEE', borderRadius: '12px', cursor: 'pointer' }}>
                    <div style={{ width: '40px', height: '40px', background: '#F8F6F6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#999' }}></div></div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>To Do</div><div style={{ fontSize: '12px', color: '#666' }}>Ready to start this task</div></div>
                  </div>
                  <div onClick={function() { updateTaskStatus('in-progress', '#4A90A4', 'In Progress'); }} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '2px solid #4A90A4', borderRadius: '12px', cursor: 'pointer', background: 'rgba(74, 144, 164, 0.05)' }}>
                    <div style={{ width: '40px', height: '40px', background: 'rgba(74, 144, 164, 0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#4A90A4' }}></div></div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>In Progress</div><div style={{ fontSize: '12px', color: '#666' }}>Currently working on this</div></div>
                    <div style={{ color: '#4A90A4' }}><CheckIcon size={16} /></div>
                  </div>
                  <div onClick={function() { updateTaskStatus('paused', '#B8860B', 'Paused'); }} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '2px solid #F0EEEE', borderRadius: '12px', cursor: 'pointer' }}>
                    <div style={{ width: '40px', height: '40px', background: '#F8F6F6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#B8860B' }}></div></div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>Paused</div><div style={{ fontSize: '12px', color: '#666' }}>Temporarily stopped</div></div>
                  </div>
                  <div onClick={function() { updateTaskStatus('done', '#4A7C59', 'Done'); }} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', border: '2px solid #F0EEEE', borderRadius: '12px', cursor: 'pointer' }}>
                    <div style={{ width: '40px', height: '40px', background: '#F8F6F6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#4A7C59' }}></div></div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>Done</div><div style={{ fontSize: '12px', color: '#666' }}>Task completed successfully</div></div>
                  </div>
                </div>
                <button onClick={function() {
                  const modal = document.getElementById('status-modal');
                  if (modal) modal.style.display = 'none';
                }} style={{ width: '100%', padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#F8F6F6', color: '#666' }}>Cancel</button>
              </div>
            </div>

            {/* Date modal */}
            <div id="date-modal" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.5)', display: 'none', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', maxWidth: '340px', width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }}>Change Due Date</div>
                  <button onClick={function() {
                    const modal = document.getElementById('date-modal');
                    if (modal) modal.style.display = 'none';
                  }} style={{ background: 'none', border: 'none', padding: '0', cursor: 'pointer', color: '#666', minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CloseIcon size={16} />
                  </button>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Quick Select</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div onClick={function() { updateDueDate(0, 'today'); }} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: '#F8F6F6', borderRadius: '12px', cursor: 'pointer' }}>
                      <div style={{ width: '32px', height: '32px', background: '#B8860B', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}><CalendarIcon size={14} /></div>
                      <div><div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>Today</div><div style={{ fontSize: '12px', color: '#666' }}>Due today</div></div>
                    </div>
                    <div onClick={function() { updateDueDate(1, 'tomorrow'); }} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: '#F8F6F6', borderRadius: '12px', cursor: 'pointer' }}>
                      <div style={{ width: '32px', height: '32px', background: '#4A90A4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', color: 'white' }}>⏰</div>
                      <div><div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>Tomorrow</div><div style={{ fontSize: '12px', color: '#666' }}>Due tomorrow</div></div>
                    </div>
                    <div onClick={function() { updateDueDate(3, 'this week'); }} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: '#F8F6F6', borderRadius: '12px', cursor: 'pointer' }}>
                      <div style={{ width: '32px', height: '32px', background: '#4A7C59', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', color: 'white' }}>📆</div>
                      <div><div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>This Friday</div><div style={{ fontSize: '12px', color: '#666' }}>Due in 3 days</div></div>
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Custom Date</div>
                  <input id="custom-date-picker" type="date" defaultValue="2024-10-25" onChange={function(e) {
                    const selectedDate = new Date(e.target.value);
                    const today = new Date();
                    const diffTime = selectedDate - today;
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    updateDueDate(diffDays, 'custom');
                  }} style={{ width: '100%', padding: '12px 16px', border: '2px solid #F0EEEE', borderRadius: '12px', fontSize: '14px', background: 'white', cursor: 'pointer' }} />
                </div>
                <button onClick={function() {
                  const modal = document.getElementById('date-modal');
                  if (modal) modal.style.display = 'none';
                }} style={{ width: '100%', padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#F8F6F6', color: '#666' }}>Cancel</button>
              </div>
            </div>

            {/* Add Note Modal */}
            <div id="add-note-modal" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.5)', display: 'none', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', maxWidth: '340px', width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }}>Add Family Note</div>
                  <button onClick={function() {
                    const modal = document.getElementById('add-note-modal');
                    if (modal) { modal.style.display = 'none'; const textarea = document.getElementById('note-text'); if (textarea) textarea.value = ''; }
                  }} style={{ background: 'none', border: 'none', padding: '0', cursor: 'pointer', color: '#666', minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CloseIcon size={16} />
                  </button>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Your Note</label>
                  <textarea id="note-text" placeholder="Share thoughts, ask questions, or @mention family members..." style={{ width: '100%', padding: '12px', border: '2px solid #F0EEEE', borderRadius: '8px', fontSize: '14px', minHeight: '120px', resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.5' }} />
                </div>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
                  <div onClick={function() { addMention('@Eleanor'); }} style={{ background: 'rgba(74, 144, 164, 0.1)', color: '#4A90A4', padding: '6px 12px', borderRadius: '16px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>@Eleanor</div>
                  <div onClick={function() { addMention('@Maria'); }} style={{ background: 'rgba(74, 144, 164, 0.1)', color: '#4A90A4', padding: '6px 12px', borderRadius: '16px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>@Maria</div>
                  <div onClick={function() { addMention('@Everyone'); }} style={{ background: 'rgba(74, 144, 164, 0.1)', color: '#4A90A4', padding: '6px 12px', borderRadius: '16px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>@Everyone</div>
                </div>
                <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                  <button onClick={function() {
                    const modal = document.getElementById('add-note-modal');
                    if (modal) { modal.style.display = 'none'; const textarea = document.getElementById('note-text'); if (textarea) textarea.value = ''; }
                  }} style={{ flex: 1, padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#F8F6F6', color: '#666' }}>Cancel</button>
                  <button onClick={function() { saveNote(); }} style={{ flex: 1, padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#4A90A4', color: 'white' }}>Add Note</button>
                </div>
              </div>
            </div>

            {/* Add Facility Modal */}
            <div id="add-facility-modal" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.5)', display: 'none', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
              <div style={{ background: 'white', borderRadius: '20px', padding: '24px', maxWidth: '340px', width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a' }}>Add a Facility</div>
                  <button onClick={function() {
                    const modal = document.getElementById('add-facility-modal');
                    if (modal) { modal.style.display = 'none'; const searchInput = document.getElementById('facility-search'); if (searchInput) searchInput.value = ''; }
                  }} style={{ background: 'none', border: 'none', padding: '0', cursor: 'pointer', color: '#666', minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CloseIcon size={16} />
                  </button>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Search for a facility</label>
                  <input id="facility-search" type="text" placeholder="Type facility name or address..." onInput={function(e) { searchFacilities(e.target.value); }} style={{ width: '100%', padding: '12px', border: '2px solid #F0EEEE', borderRadius: '8px', fontSize: '14px' }} />
                  <div id="search-results" style={{ display: 'none', maxHeight: '200px', overflowY: 'auto', border: '1px solid #F0EEEE', borderTop: 'none', borderRadius: '0 0 8px 8px', background: 'white', position: 'absolute', width: 'calc(100% - 48px)', zIndex: 10 }}></div>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Suggested</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div onClick={function() { selectSuggestion('Golden Years Assisted Living', 'Springfield, MA · 3.2 mi'); }} style={{ padding: '12px', border: '1px solid #F0EEEE', borderRadius: '8px', cursor: 'pointer' }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>Golden Years Assisted Living</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Springfield, MA · 3.2 mi</div>
                    </div>
                    <div onClick={function() { selectSuggestion('Maple Grove Senior Care', 'Ludlow, MA · 1.8 mi'); }} style={{ padding: '12px', border: '1px solid #F0EEEE', borderRadius: '8px', cursor: 'pointer' }}>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '2px' }}>Maple Grove Senior Care</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Ludlow, MA · 1.8 mi</div>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                  <button onClick={function() {
                    const modal = document.getElementById('add-facility-modal');
                    if (modal) { modal.style.display = 'none'; const searchInput = document.getElementById('facility-search'); if (searchInput) searchInput.value = ''; }
                  }} style={{ flex: 1, padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#F8F6F6', color: '#666' }}>Cancel</button>
                  <button onClick={function() { addFacility(); }} style={{ flex: 1, padding: '12px', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', background: '#4A90A4', color: 'white' }}>Add to List</button>
                </div>
              </div>
            </div>

          </div>
          {renderBottomNavigation()}
        </div>
      );
    }

    function searchFacilities(query) {
      const resultsDiv = document.getElementById('search-results');
      
      if (query.length > 2) {
        // In real app, this would query facility database/APIs
        resultsDiv.style.display = 'block';
        resultsDiv.innerHTML = `
          <div style="padding: 12px; cursor: pointer; border-bottom: 1px solid #F8F6F6;" onclick="selectSearchResult('${query} Senior Living', 'Auto-detected address')">
            <div style="font-size: 14px; font-weight: 600; color: #1a1a1a; margin-bottom: 2px;">${query} Senior Living</div>
            <div style="font-size: 12px; color: #666;">Auto-detected from search</div>
          </div>
          <div style="padding: 12px; cursor: pointer;" onclick="selectSearchResult('${query} Care Center', 'Nearby location')">
            <div style="font-size: 14px; font-weight: 600; color: #1a1a1a; margin-bottom: 2px;">${query} Care Center</div>
            <div style="font-size: 12px; color: #666;">Nearby location</div>
          </div>
        `;
      } else {
        resultsDiv.style.display = 'none';
      }
    }

    function selectSuggestion(name, address) {
      const searchInput = document.getElementById('facility-search');
      if (searchInput) {
        searchInput.value = name;
      }
      const resultsDiv = document.getElementById('search-results');
      if (resultsDiv) {
        resultsDiv.style.display = 'none';
      }
    }

    function selectSearchResult(name, address) {
      const searchInput = document.getElementById('facility-search');
      if (searchInput) {
        searchInput.value = name;
      }
      const resultsDiv = document.getElementById('search-results');
      if (resultsDiv) {
        resultsDiv.style.display = 'none';
      }
    }

    function addFacility() {
      const searchInput = document.getElementById('facility-search');
      const facilityName = searchInput ? searchInput.value.trim() : '';
      
      if (facilityName) {
        const modal = document.getElementById('add-facility-modal');
        if (modal) {
          modal.style.display = 'none';
        }
        
        // Show confirmation toast
        const toast = document.createElement('div');
        toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #1a1a1a; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
        toast.innerHTML = `🏥 "${facilityName}" has been added to your list. We'll research contact details automatically.`;
        document.body.appendChild(toast);
        
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 4000);
        
        // Clear the search input
        if (searchInput) {
          searchInput.value = '';
        }
        
        // In a real app, this would add the facility to the facilities list
        console.log('Facility added:', facilityName);
      } else {
        // Show error message
        const toast = document.createElement('div');
        toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #d32f2f; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
        toast.innerHTML = 'Please select or enter a facility name.';
        document.body.appendChild(toast);
        
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 3000);
      }
    }

    function addMention(mention) {
      const textarea = document.getElementById('note-text');
      if (textarea) {
        const currentText = textarea.value;
        const cursorPosition = textarea.selectionStart;
        const newText = currentText.slice(0, cursorPosition) + mention + ' ' + currentText.slice(cursorPosition);
        textarea.value = newText;
        textarea.focus();
        // Move cursor after the mention
        textarea.setSelectionRange(cursorPosition + mention.length + 1, cursorPosition + mention.length + 1);
      }
    }

    function saveNote() {
      const noteText = document.getElementById('note-text');
      if (noteText && noteText.value.trim()) {
        const modal = document.getElementById('add-note-modal');
        if (modal) {
          modal.style.display = 'none';
        }
        
        // Show confirmation toast
        const toast = document.createElement('div');
        toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #1a1a1a; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
        toast.innerHTML = '📝 Note added! Family members mentioned will receive notifications.';
        document.body.appendChild(toast);
        
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 4000);
        
        // Clear the textarea
        noteText.value = '';
        
        // In a real app, this would add the note to the notes list
        console.log('Note added:', noteText.value);
      } else {
        // Show error message
        const toast = document.createElement('div');
        toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #d32f2f; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
        toast.innerHTML = 'Please enter a note before saving.';
        document.body.appendChild(toast);
        
        setTimeout(() => {
          document.body.removeChild(toast);
        }, 3000);
      }
    }

    function updateDueDate(daysFromToday, type) {
      const today = new Date();
      const targetDate = new Date(today);
      targetDate.setDate(today.getDate() + daysFromToday);
      
      const dayName = targetDate.toLocaleDateString('en-US', { weekday: 'long' });
      const dateText = document.getElementById('due-date-text');
      const modal = document.getElementById('date-modal');
      
      let daysText = '';
      if (daysFromToday === 0) {
        daysText = 'Due today';
      } else if (daysFromToday === 1) {
        daysText = 'Due tomorrow';
      } else if (daysFromToday > 1) {
        daysText = `Due in ${daysFromToday} days`;
      } else {
        daysText = `Overdue by ${Math.abs(daysFromToday)} days`;
      }
      
      if (dateText) {
        dateText.textContent = `Due ${dayName} - ${daysText}`;
      }
      
      if (modal) {
        modal.style.display = 'none';
      }
      
      // Show confirmation toast
      const toast = document.createElement('div');
      toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #1a1a1a; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
      toast.innerHTML = `Due date updated to ${dayName}`;
      document.body.appendChild(toast);
      
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 3000);
    }

    function updateTaskStatus(status, color, text) {
      const statusDot = document.getElementById('status-dot');
      const statusText = document.getElementById('status-text');
      const modal = document.getElementById('status-modal');
      
      if (statusDot && statusText) {
        statusDot.style.background = color;
        statusText.textContent = text;
      }
      
      if (modal) {
        modal.style.display = 'none';
      }
      
      // Show a brief confirmation
      const toast = document.createElement('div');
      toast.style.cssText = 'position: fixed; bottom: 120px; left: 50%; transform: translateX(-50%); background: #1a1a1a; color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px; z-index: 1001; display: flex; align-items: center; gap: 12px;';
      toast.innerHTML = `Status updated to ${text}`;
      document.body.appendChild(toast);
      
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 3000);
    }

    if (currentScreen === 'discover') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          {/* Search Bar */}
          <div style={{ padding: '20px', background: '#FDFCFC', borderBottom: '1px solid #E8E6E6' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '20px', height: '20px', color: '#4A90A4', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🔍</div>
                <input 
                  type="text" 
                  placeholder="What do you need help with?" 
                  style={{ 
                    flex: 1, 
                    border: 'none', 
                    outline: 'none', 
                    fontSize: '16px', 
                    color: '#1A1A1A',
                    background: 'transparent'
                  }} 
                />
              </div>
            </div>
          </div>

          {/* AI Chat Interface */}
          {(discoverPhase === 'ai-engagement' || discoverPhase === 'conversation' || discoverPhase === 'awaiting-response' || discoverPhase === 'searching' || discoverPhase === 'view-results') && (
            <div style={{ 
              position: 'absolute', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0, 
              background: 'rgba(0,0,0,0.5)', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 1000
            }}>
              <div style={{ 
                background: 'white', 
                borderRadius: '20px', 
                padding: '24px', 
                margin: '20px',
                maxWidth: '350px',
                width: 'calc(100% - 40px)',
                maxHeight: '70vh',
                overflowY: 'auto',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                position: 'relative'
              }}>
                {/* Close button */}
                <button 
                  onClick={() => {
                    setDiscoverPhase('empty');
                    setChatbotManuallyClosed(true);
                  }}
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    background: 'none',
                    border: 'none',
                    color: '#999',
                    cursor: 'pointer',
                    padding: '0',
                    borderRadius: '50%',
                    width: '44px',
                    height: '44px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'background-color 0.2s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                  onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  <CloseIcon size={16} />
                </button>
                
                <div style={{ marginBottom: '20px' }}>
                  <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>Ask Solvyn</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>Your Navigation Guide</div>
                </div>

                <div data-chat-container style={{ marginBottom: '20px', maxHeight: '300px', overflowY: 'auto' }}>
                  {discoverMessages.map((message, index) => (
                    <div key={index} data-message-type={message.type} style={{ 
                      marginBottom: '12px',
                      display: 'flex',
                      justifyContent: message.type === 'user' ? 'flex-end' : 'flex-start'
                    }}>
                      <div style={{
                        background: message.type === 'user' ? '#4A90A4' : '#F0F0F0',
                        color: message.type === 'user' ? 'white' : '#1a1a1a',
                        padding: '12px 16px',
                        borderRadius: '16px',
                        maxWidth: '85%',
                        fontSize: '14px',
                        lineHeight: '1.4',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        position: 'relative'
                      }}>
                        {message.text}
                      </div>
                    </div>
                  ))}
                  
                  {/* AI Typing - Simple container like user typing */}
                  {discoverWorking && (
                    <div style={{ 
                      marginBottom: '12px',
                      display: 'flex',
                      justifyContent: 'flex-start'
                    }}>
                      <div style={{
                        background: '#F0F0F0',
                        color: '#1a1a1a',
                        padding: '12px 16px',
                        borderRadius: '16px',
                        maxWidth: '85%',
                        fontSize: '14px',
                        lineHeight: '1.4',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap'
                      }}>
                        <textarea
                          value={aiTypingText}
                          readOnly
                          style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'inherit',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            lineHeight: 'inherit',
                            width: '100%',
                            resize: 'none',
                            outline: 'none',
                            padding: '0',
                            margin: '0',
                            overflow: 'hidden',
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            minHeight: '20px'
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>


                {discoverPhase === 'conversation' && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <textarea
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        placeholder="Type your message..."
                      style={{ 
                        flex: 1, 
                        padding: '12px 16px', 
                          borderRadius: '20px',
                          border: '1px solid #E0E0E0',
                        fontSize: '14px', 
                          outline: 'none',
                          background: '#F8F8F8',
                          resize: 'none',
                          minHeight: '44px',
                          maxHeight: '120px',
                          lineHeight: '1.4',
                          fontFamily: 'inherit',
                          overflow: 'hidden'
                        }}
                        disabled={isTyping}
                        rows={1}
                        onInput={(e) => {
                          e.target.style.height = 'auto';
                          e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                        }}
                      />
                      <button
                        onClick={sendMessage}
                        disabled={!userInput.trim() || isTyping}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          background: userInput.trim() && !isTyping ? '#4A90A4' : '#E0E0E0',
                        color: 'white', 
                          border: 'none',
                          cursor: userInput.trim() && !isTyping ? 'pointer' : 'not-allowed',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '16px'
                        }}
                      >
                        <SendIcon />
                    </button>
                    </div>
                    {showTypingButton && (
                    <button 
                        onClick={simulateTyping}
                        disabled={isTyping}
                      style={{ 
                          width: '100%',
                        padding: '12px 16px', 
                        borderRadius: '8px', 
                        fontSize: '14px', 
                        fontWeight: '500', 
                          cursor: isTyping ? 'not-allowed' : 'pointer',
                          background: isTyping ? '#E0E0E0' : 'transparent', 
                          color: isTyping ? '#999' : '#4A90A4', 
                        border: '1px solid #4A90A4' 
                      }}
                    >
                        {isTyping ? 'Typing...' : 'Simulate Typing'}
                    </button>
                    )}
                  </div>
                )}

                {/* Second Simulated Typing */}
                {discoverPhase === 'awaiting-response' && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <textarea
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        placeholder="Type your message..."
                        style={{
                          flex: 1,
                          padding: '12px 16px',
                          borderRadius: '20px',
                          border: '1px solid #E0E0E0',
                          fontSize: '14px',
                          outline: 'none',
                          background: '#F8F8F8',
                          resize: 'none',
                          minHeight: '44px',
                          maxHeight: '120px',
                          lineHeight: '1.4',
                          fontFamily: 'inherit',
                          overflow: 'hidden'
                        }}
                        disabled={isTyping}
                        rows={1}
                        onInput={(e) => {
                          e.target.style.height = 'auto';
                          e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                        }}
                      />
                      <button
                        onClick={sendSecondMessage}
                        disabled={!userInput.trim() || isTyping}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          background: userInput.trim() && !isTyping ? '#4A90A4' : '#E0E0E0',
                          color: 'white',
                          border: 'none',
                          cursor: userInput.trim() && !isTyping ? 'pointer' : 'not-allowed',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '16px'
                        }}
                      >
                        <SendIcon />
                      </button>
                    </div>
                    {showTypingButton && (
                    <button 
                        onClick={simulateSecondTyping}
                      disabled={isTyping}
                      style={{ 
                        width: '100%',
                        padding: '12px 16px', 
                        borderRadius: '8px', 
                        fontSize: '14px', 
                        fontWeight: '500', 
                        cursor: isTyping ? 'not-allowed' : 'pointer', 
                          background: isTyping ? '#E0E0E0' : '#F0F0F0',
                        color: isTyping ? '#999' : '#4A90A4', 
                          border: '1px solid #E0E0E0'
                      }}
                    >
                      {isTyping ? 'Typing...' : 'Simulate Typing'}
                    </button>
                    )}
                  </div>
                )}

                {/* Searching Phase - Spinner */}
                {discoverPhase === 'searching' && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '20px' }}>
                    <div style={{ 
                      width: '20px', 
                      height: '20px', 
                      border: '2px solid #4A90A4', 
                      borderTop: '2px solid transparent', 
                      borderRadius: '50%', 
                      animation: 'spin 1s linear infinite' 
                    }}></div>
                    <span style={{ color: '#4A90A4', fontSize: '16px', fontWeight: '500' }}>
                      Creating Eleanor's journey...
                    </span>
                  </div>
                )}

                {/* View Results Button */}
                {discoverPhase === 'view-results' && (
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <button 
                      onClick={viewResults}
                      style={{ 
                        flex: 1, 
                        padding: '12px 16px', 
                        borderRadius: '8px', 
                        fontSize: '14px', 
                        fontWeight: '500', 
                        cursor: 'pointer', 
                        background: '#4A90A4', 
                        color: 'white', 
                        border: 'none' 
                      }}
                    >
                      View Journeys
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Results Display */}
          {discoverPhase === 'results' && (
            <div style={{ flex: 1, overflowY: 'auto', padding: '20px', paddingBottom: '120px' }}>
              {/* AI-Generated Journey */}

              <div style={{ background: '#F8F6F6', borderRadius: '12px', padding: '20px', marginBottom: '24px', border: '2px solid transparent', transition: 'all 0.2s ease' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: '#1A1A1A', marginBottom: '4px' }}>Assisted Living Transition</div>
                    <div style={{ fontSize: '14px', color: '#6B6B6B', fontWeight: '400' }}>Personalized for Eleanor</div>
                  </div>
                </div>
                
                <div style={{ fontSize: '14px', color: '#2D2C2C', lineHeight: '1.4', marginBottom: '16px' }}>
                  Custom journey tailored to Eleanor's Portuguese heritage, location in Ludlow, MA, and your family's specific needs. Includes cultural resources and bilingual support options.
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#6B6B6B' }}>
                      <div style={{ width: '14px', height: '14px', stroke: '#6B6B6B', strokeWidth: '2', fill: 'none' }}>⏱️</div>
                      8 phases
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#6B6B6B' }}>
                      <div style={{ width: '14px', height: '14px', stroke: '#6B6B6B', strokeWidth: '2', fill: 'none' }}>👥</div>
                      2.1k users
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', background: 'transparent', color: '#4A90A4', border: '1px solid #4A90A4' }}>Preview</button>
                  <button onClick={function() { setCurrentScreen('journey-map'); }} style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', background: '#4A90A4', color: 'white', border: 'none' }}>Start</button>
                </div>
              </div>
            </div>
          )}

          {/* Empty State */}
          {discoverPhase === 'empty' && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>Discover Your Journey</div>
                <div style={{ fontSize: '14px', color: '#666' }}>AI is preparing personalized recommendations...</div>
              </div>
            </div>
          )}

          {renderBottomNavigation()}
        </div>
      );
    }

    if (currentScreen === 'account') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          {/* Profile Header */}
          <div style={{ padding: '32px 20px 24px', textAlign: 'center', background: 'linear-gradient(135deg, #4A90A4, #357A8A)', color: 'white' }}>
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255, 255, 255, 0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', fontWeight: '600', margin: '0 auto 16px' }}>
              TS
            </div>
            <div style={{ fontSize: '22px', fontWeight: '600', marginBottom: '4px' }}>Tess Smith</div>
            <div style={{ fontSize: '16px', opacity: 0.9 }}>GeauxTess@ggmmail.test</div>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', padding: '20px', paddingBottom: '120px' }}>
            {/* Personal Info Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '24px', height: '24px', color: '#4A90A4', fontSize: '18px' }}>👤</div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Personal Info</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Name</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Tess Smith</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Edit</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Email</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>GeauxTess@ggmmail.test</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Edit</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Phone</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>555-617-5208</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Edit</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Birthday</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>June 20, 1974</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Edit</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Address</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>132 Abraham Rd, Concord, MA</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Edit</div>
                </div>
              </div>
            </div>

            {/* Care Team Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '24px', height: '24px', color: '#4A90A4', fontSize: '18px' }}>👥</div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Care Team</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Family Members</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>3 people</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Manage</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Emergency Contacts</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>2 contacts</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>Manage</div>
                </div>
              </div>
            </div>

            {/* Privacy & Data Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '24px', height: '24px', color: '#4A90A4', fontSize: '18px' }}>🔒</div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Privacy & Data</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Data Usage</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>View your data</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Privacy Settings</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Control your privacy</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Download Data</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Export your information</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
              </div>
            </div>

            {/* Notifications Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '24px', height: '24px', color: '#4A90A4', fontSize: '18px' }}>🔔</div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Notifications</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Push Notifications</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Enabled</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Email Notifications</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Enabled</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
              </div>
            </div>

            {/* Support Section */}
            <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '24px', height: '24px', color: '#4A90A4', display: 'flex', alignItems: 'center' }}><QuestionIcon size={22} /></div>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Support</div>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '12px', borderBottom: '1px solid #F0EEEE' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Help Center</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Get help and support</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: '#666', marginBottom: '2px' }}>Contact Us</div>
                    <div style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '500' }}>Send feedback</div>
                  </div>
                  <div style={{ color: '#4A90A4', fontSize: '14px' }}>→</div>
                </div>
              </div>
            </div>
          </div>
          {renderBottomNavigation()}
        </div>
      );
    }

    if (currentScreen === 'lyla-detail') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fdfcfc' }}>
          <div style={{ padding: '20px', background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', borderBottom: '1px solid #E8E6E6' }}>
            <button onClick={() => setCurrentScreen('journeys')} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'white', fontSize: '16px', fontWeight: '500', marginBottom: '16px', background: 'none', border: 'none', cursor: 'pointer' }}>
              ← Your Journeys
            </button>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: '600', color: 'white' }}>🐕</div>
                <div>
                  <h1 style={{ fontSize: '22px', fontWeight: '700', color: 'white', marginBottom: '4px' }}>Lyla</h1>
                  <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)', margin: 0 }}>4 months • Husky • Rescued</p>
                </div>
              </div>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4A7C59' }}></div>
            </div>
          </div>

          <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px 120px 20px' }}>
            {/* Active Journey */}
            <div style={{ marginTop: '20px', marginBottom: '24px' }}>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', marginBottom: '12px' }}>Active Journey</div>
              <div style={{ background: 'linear-gradient(135deg, #4A90A4 0%, #357A8A 100%)', borderRadius: '12px', padding: '20px', color: 'white' }}>
                <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Welcoming a Rescued Puppy</div>
                <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', marginBottom: '12px' }}>Potty training and crate training</div>
                <div style={{ width: '100%', height: '4px', background: 'rgba(255,255,255,0.3)', borderRadius: '2px', overflow: 'hidden', marginBottom: '8px' }}>
                  <div style={{ height: '100%', background: 'rgba(255,255,255,0.8)', borderRadius: '2px', width: '40%' }}></div>
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.8)' }}>Phase 2 of 5</div>
              </div>
            </div>

            {/* Routines */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Routines</div>
                <button onClick={() => setCurrentScreen('lyla-routines')} style={{ color: '#4A90A4', fontSize: '14px', fontWeight: '500', background: 'none', border: 'none', cursor: 'pointer' }}>
                  See all →
                </button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Morning Feeding Routine</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>7:00 AM • High-quality puppy food</div>
                </div>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Evening Walk & Play</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>6:00 PM • Exercise and socialization</div>
                </div>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Bedtime Routine</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>9:00 PM • Calm activities and crate time</div>
                </div>
              </div>
            </div>

            {/* Resources */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Resources</div>
                <button onClick={() => setCurrentScreen('lyla-resources')} style={{ color: '#4A90A4', fontSize: '14px', fontWeight: '500', background: 'none', border: 'none', cursor: 'pointer' }}>
                  See all →
                </button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Veterinary Care</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Dr. Sarah Johnson • Next visit: Dec 15</div>
                </div>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Puppy Training Classes</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Pawsitive Training Center • Starts Jan 8</div>
                </div>
                <div style={{ background: 'white', borderRadius: '8px', padding: '12px', border: '1px solid #E8E6E6' }}>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', marginBottom: '4px' }}>Pet Insurance</div>
                  <div style={{ fontSize: '12px', color: '#6b6b6b' }}>Healthy Paws • Coverage active</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', background: '#FDFCFC' }}>
        <h1 style={{ color: '#4A90A4' }}>Solvyn</h1>
      </div>
    );
  }

  function renderBottomNavigation() {
    if (['splash', 'signin', 'pulse-check', 'onboarding-welcome', 'onboarding-pulse', 'onboarding-location', 'onboarding-handoff', 'onboarding-chat', 'onboarding-building', 'onboarding-roadmap', 'onboarding-save', 'onboarding-intake', 'onboarding-goals'].includes(currentScreen)) return null;

    const journeyScreens = ['journeys', 'eleanor-detail', 'eleanor-routines', 'eleanor-resources', 'eleanor-profile', 'caroline-detail', 'tess-detail', 'journey-map', 'milestone-detail', 'task-detail'];
    const homeActive = currentScreen === 'home';
    const journeysActive = journeyScreens.includes(currentScreen);
    const discoverActive = currentScreen === 'discover';
    const accountActive = currentScreen === 'account';

    const tabBtn = {
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
      background: 'transparent', border: 'none', cursor: 'pointer', padding: '8px 16px',
      borderRadius: '12px', transition: 'all 0.2s ease', minWidth: '44px', minHeight: '44px',
      justifyContent: 'center',
    };

    return (
      <div style={{
        position: 'absolute', bottom: '0', left: '0', right: '0',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-around',
        paddingTop: '8px', paddingBottom: '8px',
        zIndex: 100, boxShadow: '0 -1px 0 rgba(0,0,0,0.06)',
      }}>

        {/* Home */}
        <button onClick={function() { handleScreenChange('home'); }} style={{ ...tabBtn, color: homeActive ? '#4A90A4' : '#8B8B8B' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={homeActive ? '2.2' : '1.8'} strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
            <polyline points="9 21 9 12 15 12 15 21"/>
          </svg>
          <span style={{ fontSize: '11px', fontWeight: homeActive ? '600' : '500', letterSpacing: '0.2px' }}>Home</span>
        </button>

        {/* Journeys */}
        <button onClick={function() { handleScreenChange('journeys'); }} style={{ ...tabBtn, color: journeysActive ? '#4A90A4' : '#8B8B8B' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={journeysActive ? '2.2' : '1.8'} strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
          <span style={{ fontSize: '11px', fontWeight: journeysActive ? '600' : '500', letterSpacing: '0.2px' }}>Journeys</span>
        </button>

        {/* Ask Solvyn - Center */}
        <button
          onClick={function() {
            setShowAIChat(true);
            if (demoMode) {
              setActiveScenario('general');
              setAiMessages([{ type: 'ai', text: "Hi! I'm Solvyn, your AI assistant. How can I help you with Eleanor's care today?" }]);
            } else {
              setActiveScenario('general');
              setAiMessages([{ type: 'ai', text: "Hi Tess! What would you like guidance with today?" }]);
            }
          }}
          style={{ ...tabBtn, padding: '0 12px', marginTop: '-20px', gap: '5px' }}
        >
          <div style={{
            width: '52px', height: '52px',
            background: 'linear-gradient(135deg, #4A90A4, #357A8A)',
            borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(74, 144, 164, 0.4)', border: '3px solid white',
          }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
            </svg>
          </div>
          <span style={{ fontSize: '11px', fontWeight: '600', color: '#4A90A4', letterSpacing: '0.2px' }}>Ask</span>
        </button>

        {/* Discover */}
        <button onClick={function() { handleScreenChange('discover'); }} style={{ ...tabBtn, color: discoverActive ? '#4A90A4' : '#8B8B8B' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={discoverActive ? '2.2' : '1.8'} strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <span style={{ fontSize: '11px', fontWeight: discoverActive ? '600' : '500', letterSpacing: '0.2px' }}>Discover</span>
        </button>

        {/* Account */}
        <button onClick={function() { handleScreenChange('account'); }} style={{ ...tabBtn, color: accountActive ? '#4A90A4' : '#8B8B8B' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={accountActive ? '2.2' : '1.8'} strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span style={{ fontSize: '11px', fontWeight: accountActive ? '600' : '500', letterSpacing: '0.2px' }}>Account</span>
        </button>

      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      height: '100%',
      background: '#ffffff',
      overflow: 'hidden',
      position: 'relative',
    }}>
            

            {/* AI Chat Interface - Global */}
            {showAIChat && (
              <div style={{ position: 'absolute', top: '0', left: '0', right: '0', bottom: '0', background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
                <div style={{ background: 'white', borderRadius: '20px', padding: '24px', maxWidth: '400px', width: '100%', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{ width: '40px', height: '40px', background: '#4A90A4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}><SparklesIcon size={20} /></div>
                      <div>
                        <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Ask Solvyn</div>
                        <div style={{ fontSize: '14px', color: '#666' }}>
                          {demoMode ? `Demo Mode - ${activeScenario}` : 'Your Navigation Guide'}
                        </div>
                      </div>
                    </div>
                    <button onClick={function() { setShowAIChat(false); }} style={{ background: '#F8F6F6', border: 'none', borderRadius: '8px', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#666' }}><CloseIcon size={16} /></button>
                  </div>

                  <div style={{ flex: 1, overflowY: 'auto', marginBottom: '20px', padding: '16px', background: '#F8F6F6', borderRadius: '12px', maxHeight: '300px' }}>
                    {aiMessages.map((message, index) => (
                      <div key={index} style={{ marginBottom: '16px', display: 'flex', flexDirection: 'column', alignItems: message.type === 'user' ? 'flex-end' : 'flex-start' }}>
                        <div style={{ 
                          background: message.type === 'user' ? '#4A90A4' : 'white', 
                          color: message.type === 'user' ? 'white' : '#1a1a1a',
                          padding: '12px 16px', 
                          borderRadius: '16px', 
                          maxWidth: '80%',
                          fontSize: '14px',
                          lineHeight: '1.4',
                          boxShadow: message.type === 'ai' ? '0 1px 4px rgba(0,0,0,0.06)' : 'none'
                        }}>
                          {message.text}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div style={{ padding: '16px', borderTop: '1px solid #F0EEEE' }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                      <textarea
                        value={aiChatInput}
                        onChange={(e) => setAiChatInput(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            sendAiChatMessage();
                          }
                        }}
                        placeholder="Type your message..."
                        style={{
                          flex: 1,
                          padding: '12px',
                          border: '2px solid #E0E0E0',
                          borderRadius: '12px',
                          fontSize: '14px',
                          fontFamily: 'inherit',
                          resize: 'none',
                          minHeight: '44px',
                          maxHeight: '120px',
                          outline: 'none',
                          transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#4A90A4';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#E0E0E0';
                        }}
                      />
                      <button
                        onClick={sendAiChatMessage}
                        disabled={!aiChatInput.trim() || aiWorking}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          background: aiChatInput.trim() && !aiWorking ? '#4A90A4' : '#E0E0E0',
                          color: 'white',
                          border: 'none',
                          cursor: aiChatInput.trim() && !aiWorking ? 'pointer' : 'not-allowed',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '16px'
                        }}
                      >
                        <SendIcon />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            <div key={currentScreen} className={transitionClass} style={{ height: '100%', position: 'relative' }}>
              {renderScreen()}
              {/* Scroll fade indicator — fades content into background just above nav bar */}
              {!['splash', 'signin', 'pulse-check', 'onboarding-welcome', 'onboarding-pulse', 'onboarding-location', 'onboarding-handoff', 'onboarding-chat', 'onboarding-building', 'onboarding-roadmap', 'onboarding-save', 'onboarding-intake', 'onboarding-goals'].includes(currentScreen) && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '120px',
                  background: 'linear-gradient(to bottom, rgba(253,252,252,0) 0%, rgba(253,252,252,0.97) 100%)',
                  pointerEvents: 'none',
                  zIndex: 10,
                }} />
              )}
            </div>

            {renderBottomNavigation()}
  </div>
  );
}

export default SolvynApp;
